export const WORDS = [
  'ちいさな',
  'がくせい',
  'ぶたにく',
  'かいもの',
  'たくさん',
  'だいがく',
  'あぶない',
  'かいだん',
  'まいとし',
  'はじまる',
  'なんでも',
  'はなれる',
  'ばいりつ',
  'おかしい',
  'ついらく',
  'おさない',
  'かんむり',
  'こごえる',
  'てつだう',
  'あまえる',
  'みちびく',
  'つなげる',
  'たがやす',
  'エンジン',
  'たいいく',
  'ていけい',
  'けんぜん',
  'けわしい',
  'どうてき',
  'けんこう',
  'へいじつ',
  'あんざん',
  'なにより',
  'あいする',
  'はいれつ',
  'ぼうふう',
  'かんしん',
  'ねんだい',
  'ばくはつ',
  'ゆうぼう',
  'はいすい',
  'ほうほう',
  'めいぶつ',
  'ほうたい',
  'さいさん',
  'そなえる',
  'ふうせん',
  'つりあう',
  'さんせい',
  'ブローチ',
  'ドキドキ',
  'ペコペコ',
  'れいぼう',
  'はつでん',
  'いれもの',
  'びんせん',
  'はるさき',
  'ささげる',
  'いりぐち',
  'ふうけい',
  'ほうどう',
  'たんこう',
  'いろいろ',
  'けんぽう',
  'さんぷく',
  'つとめる',
  'どうして',
  'なこうど',
  'こうせい',
  'ねったい',
  'しっかり',
  'じむしょ',
  'こげちゃ',
  'けってい',
  'きりゅう',
  'きょうし',
  'しゅうし',
  'すえっこ',
  'ちょうか',
  'きゅうち',
  'リットル',
  'きょぜつ',
  'じゅんび',
  'りじゅん',
  'ほうこく',
  'ぞうげん',
  'きじゅん',
  'かくりつ',
  'あんぜん',
  'いっかつ',
  'せんじつ',
  'あやうい',
  'ふくしゃ',
  'とうそう',
  'せいてき',
  'だんけつ',
  'りったい',
  'くっきり',
  'がんらい',
  'ジーンズ',
  'しゅげい',
  'かんねん',
  'ていあん',
  'ひとがら',
  'おいこす',
  'せきたん',
  'ざんねん',
  'しょうぎ',
  'わるもの',
  'かいしゃ',
  'てっきり',
  'ほうせき',
  'てんてん',
  'てきよう',
  'よきょう',
  'みおくる',
  'おんたい',
  'かたよる',
  'なんとか',
  'しゅうり',
  'はつめい',
  'ボーナス',
  'いたって',
  'ひきだす',
  'ほうそく',
  'あんせい',
  'かいてき',
  'ふなびん',
  'りょうち',
  'たいけい',
  'つうきん',
  'おさめる',
  'いちれん',
  'かっこう',
  'まちかど',
  'きゅうじ',
  'ちちおや',
  'こんけつ',
  'つかえる',
  'いきさつ',
  'とのさま',
  'がっかり',
  'ひひょう',
  'ふちょう',
  'じつげん',
  'あみもの',
  'けっそく',
  'しゃせい',
  'のうりつ',
  'みょうじ',
  'らいにち',
  'あっさり',
  'こうくう',
  'スクール',
  'ゆうかん',
  'じんそく',
  'しょとく',
  'たっしゃ',
  'つうかん',
  'いきなり',
  'うっかり',
  'ぜひとも',
  'つめたい',
  'シーズン',
  'にっとう',
  'かなしむ',
  'たのしみ',
  'もくよう',
  'せいいく',
  'なやます',
  'ライター',
  'だんたい',
  'ふるさと',
  'ていいん',
  'もうしで',
  'ごまかす',
  'いってい',
  'せってい',
  'パチンコ',
  'かくしゅ',
  'けんがく',
  'しあがる',
  'そのうち',
  'こくさん',
  'ゆうそう',
  'こうはい',
  'げっしゃ',
  'おもわず',
  'しょうぶ',
  'げんしょ',
  'かいあく',
  'げんしゅ',
  'かぶしき',
  'はくがい',
  'おもちゃ',
  'かんとく',
  'たしょう',
  'でかける',
  'そだてる',
  'たいいん',
  'きんだい',
  'かいそう',
  'すぐれる',
  'どういん',
  'ひつぜん',
  'りっぽう',
  'せいかく',
  'ぶちょう',
  'あきらめ',
  'かきとる',
  'さんこう',
  'がっこう',
  'そんがい',
  'めいれい',
  'しんてい',
  'がくしゃ',
  'ここのつ',
  'うぬぼれ',
  'ぜいきん',
  'けいやく',
  'まごころ',
  'けいせい',
  'ぎょうぎ',
  'きゅうよ',
  'がいこく',
  'バランス',
  'たしざん',
  'もくろみ',
  'ばくだい',
  'かんばん',
  'えいぶん',
  'もうける',
  'しゅだん',
  'こぎって',
  'じょげん',
  'たいくつ',
  'かようび',
  'ちょちく',
  'あいにく',
  'チェック',
  'いちべつ',
  'けむたい',
  'まんげつ',
  'るいすい',
  'いやがる',
  'つらなる',
  'かぶせる',
  'しゃたく',
  'つかれる',
  'なんだか',
  'かたまる',
  'どりょく',
  'とうぼう',
  'ジャンル',
  'おんだん',
  'すずしい',
  'いんさつ',
  'かんする',
  'こうふく',
  'とびこむ',
  'しゅじゅ',
  'かいがら',
  'にんしん',
  'したてる',
  'ごうけい',
  'いちおう',
  'ぶつぞう',
  'かいてい',
  'れんらく',
  'スカート',
  'さいこう',
  'とにかく',
  'かいけん',
  'きょねん',
  'だいいち',
  'すなわち',
  'しょうご',
  'どうよう',
  'ふひょう',
  'つぶやく',
  'たいせつ',
  'せいみつ',
  'おんしつ',
  'はいけい',
  'すいげん',
  'タレント',
  'かいさい',
  'こうさい',
  'はんけい',
  'まいぞう',
  'べんじょ',
  'あいたい',
  'あさって',
  'うらぐち',
  'せいもん',
  'かつどう',
  'しんこく',
  'えんそく',
  'えんずる',
  'こうよう',
  'ほんたい',
  'とうぶん',
  'ひのいり',
  'すくない',
  'はんえい',
  'うりだし',
  'ぞんざい',
  'いとなむ',
  'かんこく',
  'にづくり',
  'がっちり',
  'こうつう',
  'おおよそ',
  'やっぱり',
  'ぐんぷく',
  'とうごう',
  'てっする',
  'だんめん',
  'もとめる',
  'れんめい',
  'こころえ',
  'ほうしゃ',
  'いまさら',
  'ねむたい',
  'ほほえむ',
  'そうさく',
  'さいせい',
  'はつばい',
  'ふまえる',
  'むじゃき',
  'そうおん',
  'じっくり',
  'かみそり',
  'いっしょ',
  'じゅもく',
  'いきもの',
  'よういん',
  'しんずる',
  'かしだし',
  'せいやく',
  'こうえん',
  'つうこう',
  'さっする',
  'うけとる',
  'てんすう',
  'ひらがな',
  'うちけし',
  'とうなん',
  'ひとこと',
  'とうとぶ',
  'くやしい',
  'げつまつ',
  'せいそう',
  'おおぞら',
  'たとえば',
  'ていしゃ',
  'あんなに',
  'かたまり',
  'せいてつ',
  'おさまる',
  'しんこん',
  'ひたすら',
  'ちょうさ',
  'てんかん',
  'しゃしん',
  'ちかすい',
  'あいぞう',
  'コーヒー',
  'さいけつ',
  'こうりつ',
  'とうあん',
  'よろしい',
  'さいかい',
  'びりょう',
  'まんいち',
  'めいさく',
  'かんそう',
  'おうごん',
  'しゅかん',
  'しんじゃ',
  'とりだす',
  'ぜいかん',
  'てつぼう',
  'のりもの',
  'たいした',
  'ふるまう',
  'ようえき',
  'おおぜい',
  'まぎれる',
  'ねっとう',
  'もくざい',
  'こっけい',
  'きじゅつ',
  'かんづめ',
  'たんすい',
  'くじょう',
  'ニュース',
  'かたかな',
  'チャンス',
  'ひんしゅ',
  'ハンガー',
  'まんなか',
  'かいさん',
  'がいらい',
  'ねんごう',
  'したがう',
  'とういつ',
  'えいしゃ',
  'ききょう',
  'たおれる',
  'やくだつ',
  'ガソリン',
  'しゅよう',
  'うめぼし',
  'ストロボ',
  'ぼうえき',
  'スピード',
  'みかづき',
  'えんだん',
  'たっぷり',
  'たいのう',
  'ちらかる',
  'なごやか',
  'もうれつ',
  'モーテル',
  'きょうわ',
  'へいこう',
  'かんせん',
  'しゅえん',
  'しょうり',
  'ひじゅう',
  'なげだす',
  'げんてん',
  'とくしゅ',
  'りょうど',
  'かんらん',
  'とろける',
  'としつき',
  'しんにん',
  'しんぶん',
  'とうにん',
  'あやまる',
  'ちつじょ',
  'きょうい',
  'かんぱい',
  'かんべん',
  'おかえり',
  'だいたい',
  'ごぶさた',
  'うりあげ',
  'こだわる',
  'えんりょ',
  'きにゅう',
  'ちりょう',
  'ちかごろ',
  'ステージ',
  'つとまる',
  'くらべる',
  'すいどう',
  'おごそか',
  'わりびき',
  'でんげん',
  'げんいん',
  'けいしゃ',
  'けんそん',
  'らんぼう',
  'こうずい',
  'さくしゃ',
  'とつじょ',
  'れいぞう',
  'タイマー',
  'ひんしつ',
  'むらがる',
  'けいそつ',
  'とりくむ',
  'がくもん',
  'さわやか',
  'ほうじる',
  'めんじょ',
  'はいりょ',
  'からかう',
  'くわえる',
  'ひっこす',
  'たいしょ',
  'ついせき',
  'こんなん',
  'しんぞう',
  'ひょっと',
  'つうよう',
  'やすめる',
  'びんぼう',
  'ゆうえつ',
  'けいばつ',
  'かきとめ',
  'せんげん',
  'ほどこす',
  'しぶとい',
  'スリッパ',
  'うったえ',
  'だんせい',
  'たいぼく',
  'こくれん',
  'ほうけん',
  'あやつる',
  'ぎっしり',
  'くだもの',
  'しつれん',
  'うちこむ',
  'りょかん',
  'もくろく',
  'しめきる',
  'もてなす',
  'ちかづく',
  'ひきざん',
  'かんろく',
  'ふみきり',
  'まっしろ',
  'えいせい',
  'だんてい',
  'つきなみ',
  'びみょう',
  'めっきり',
  'そうぞく',
  'かんよう',
  'さかずき',
  'プリント',
  'すいそく',
  'しゅっせ',
  'ひっかく',
  'ほうもん',
  'こきゅう',
  'ぜんたい',
  'ばくしゅ',
  'そんなに',
  'ねじれる',
  'さいほう',
  'てまわし',
  'しんせき',
  'もんどう',
  'サービス',
  'かくとく',
  'りょこう',
  'じしゅう',
  'たいりつ',
  'へんせん',
  'ストーブ',
  'さくひん',
  'こたえる',
  'ようする',
  'ぶんるい',
  'にせもの',
  'けいざい',
  'たいせい',
  'いけない',
  'せつない',
  'だっせん',
  'きんにく',
  'まかせる',
  'かくれる',
  'せいぜい',
  'きっかり',
  'すいよう',
  'かいかん',
  'ろくおん',
  'しゃがむ',
  'さいてん',
  'やじるし',
  'じんざい',
  'ぶんしょ',
  'ならべる',
  'こうそく',
  'ごうどう',
  'えんかい',
  'ほうめん',
  'しょてん',
  'ざひょう',
  'ばっする',
  'なんべい',
  'きしょう',
  'おまつり',
  'うれゆき',
  'へきえき',
  'がくねん',
  'ぼうえい',
  'かみくず',
  'てんさい',
  'じょおう',
  'おどかす',
  'オルガン',
  'いりょう',
  'けんざい',
  'どくしん',
  'じょうぶ',
  'とうだい',
  'ひきずる',
  'ユニーク',
  'どうめい',
  'おしえる',
  'ついたち',
  'これから',
  'ようやく',
  'なかゆび',
  'こうたく',
  'えんがわ',
  'しんどう',
  'しんゆう',
  'なかよし',
  'けんとう',
  'はいいろ',
  'とうみん',
  'フォーム',
  'しょうか',
  'うかべる',
  'たかめる',
  'ひといき',
  'ゆしゅつ',
  'ろんずる',
  'ここのか',
  'てんにん',
  'はげしい',
  'じっぷん',
  'かたむく',
  'たいそう',
  'やさしい',
  'さっそく',
  'うけもつ',
  'こうかい',
  'えんじょ',
  'てんいん',
  'ジャンボ',
  'まいつき',
  'メートル',
  'ハンドル',
  'かんじゃ',
  'ほんやく',
  'げしゅく',
  'げんてい',
  'こいびと',
  'いきごむ',
  'ときおり',
  'ひっこし',
  'さいがい',
  'まるめる',
  'まっさき',
  'ひきょう',
  'おつかい',
  'いじょう',
  'ていこう',
  'はんらん',
  'きんじょ',
  'ぶんぽう',
  'しいれる',
  'たいぼう',
  'ひきだし',
  'ちらかす',
  'さいくつ',
  'れんたい',
  'さいぼう',
  'そうりつ',
  'せつめい',
  'おもむき',
  'うごかす',
  'ピストル',
  'エプロン',
  'はずれる',
  'よろこび',
  'せいだい',
  'でなおし',
  'ちゅうと',
  'たいして',
  'さいはつ',
  'かぶれる',
  'グランド',
  'こまかい',
  'ひりょう',
  'れんじつ',
  'うんぬん',
  'きぎょう',
  'おくさん',
  'そうして',
  'ふんしつ',
  'けっして',
  'いっしん',
  'はんとう',
  'えんぜつ',
  'こううん',
  'ようせき',
  'ほうそう',
  'さんかく',
  'ひろげる',
  'フェリー',
  'くわわる',
  'けんちく',
  'ゆいいつ',
  'ものおと',
  'そうだん',
  'ひんぱん',
  'きちょう',
  'あばれる',
  'きょうふ',
  'とどまる',
  'とびだす',
  'いいだす',
  'あじわい',
  'しんせつ',
  'れんぽう',
  'ロッカー',
  'こんげん',
  'いちめん',
  'もよおし',
  'おてあげ',
  'たんだい',
  'ぎょせん',
  'おぼれる',
  'そろばん',
  'そうとう',
  'いしょう',
  'てんねん',
  'ところで',
  'こくぼう',
  'ひとごみ',
  'ようほう',
  'せんざい',
  'ひとすじ',
  'がいする',
  'ほんぶん',
  'かんたい',
  'しんぱい',
  'あっこう',
  'ようふく',
  'くだける',
  'つよまる',
  'じょうげ',
  'しんがり',
  'しんぜん',
  'けいさつ',
  'えんげい',
  'しびれる',
  'ちくさん',
  'ロケット',
  'たいけん',
  'つらぬく',
  'しきさい',
  'それでは',
  'レコード',
  'ちかよる',
  'りゃくす',
  'ざぶとん',
  'ろうどく',
  'きのどく',
  'おさきに',
  'しゃかい',
  'こんらん',
  'つうがく',
  'ふくめる',
  'ののしる',
  'こうさく',
  'はんたい',
  'あつまり',
  'でむかえ',
  'じしゃく',
  'ぶったい',
  'なりたつ',
  'ふりがな',
  'アメリカ',
  'あしあと',
  'さかだち',
  'どうとく',
  'がくげい',
  'なくなる',
  'せいめい',
  'おうべい',
  'さかえる',
  'れんあい',
  'にぎやか',
  'おいしい',
  'にちよう',
  'ちくせき',
  'こくゆう',
  'とうよう',
  'なだらか',
  'たずねる',
  'せいひん',
  'かたみち',
  'おばさん',
  'しらせる',
  'みんぞく',
  'なにしろ',
  'おちつく',
  'はらっぱ',
  'ようぶん',
  'うでまえ',
  'たいまん',
  'ばくだん',
  'ちゃんと',
  'きこえる',
  'ながびく',
  'ちぢまる',
  'じんこう',
  'せつりつ',
  'まっさお',
  'スマート',
  'ろうどう',
  'かいじょ',
  'めいしん',
  'のうやく',
  'ためいき',
  'こじれる',
  'はっそう',
  'ファイト',
  'ざいもく',
  'とじまり',
  'みのがす',
  'そろえる',
  'でんとう',
  'かいよう',
  'さんりん',
  'しつける',
  'へんこう',
  'たいおん',
  'いためる',
  'たんなる',
  'もたれる',
  'せいねん',
  'こんてい',
  'そこなう',
  'つうせつ',
  'あくにち',
  'まさしく',
  'おくがい',
  'ほじゅう',
  'とうけい',
  'しんだん',
  'みっせつ',
  'はらだち',
  'どうかく',
  'びょうき',
  'てんごく',
  'ながれる',
  'ぶんかい',
  'どうこう',
  'いかにも',
  'このごろ',
  'わりあい',
  'よこぎる',
  'にんめい',
  'なづける',
  'こくふく',
  'ふくそう',
  'おいつく',
  'ながめる',
  'しゃぜつ',
  'へだたる',
  'タイトル',
  'ゆうぼく',
  'にってい',
  'ぞうだい',
  'もっとも',
  'きんゆう',
  'かんれい',
  'げんだい',
  'はってん',
  'しあげる',
  'せいてい',
  'じょうき',
  'けがれる',
  'さえずる',
  'ひょうご',
  'ほうぼう',
  'べんかい',
  'いっさい',
  'うまれる',
  'あきらか',
  'さいばい',
  'げきれい',
  'しんせん',
  'すいてき',
  'さだめる',
  'きょうぎ',
  'ちぢめる',
  'あつまる',
  'さきほど',
  'そうぞう',
  'にっこり',
  'ようせい',
  'ストレス',
  'しずまる',
  'ひろめる',
  'かためる',
  'こいする',
  'よわまる',
  'いっしゅ',
  'さいじつ',
  'ちりがみ',
  'たちまち',
  'おちこむ',
  'ひあたり',
  'さいたく',
  'こんげつ',
  'きたえる',
  'それゆえ',
  'なおさら',
  'かいごう',
  'スカーフ',
  'にっこう',
  'ふくごう',
  'おおきい',
  'ぼやける',
  'りょうじ',
  'のりかえ',
  'アフリカ',
  'てちょう',
  'けいかん',
  'かんぺき',
  'あいまい',
  'のうみん',
  'ぼうとう',
  'ちょぞう',
  'かみなり',
  'めんせき',
  'ぬけだす',
  'ぜっぱん',
  'しゃせつ',
  'しなもの',
  'スタート',
  'にかよう',
  'かいさつ',
  'アイロン',
  'はいけん',
  'りゃくご',
  'ほんのう',
  'かいほう',
  'クーラー',
  'おおきな',
  'こうげん',
  'うしなう',
  'じんかく',
  'せつぞく',
  'モーター',
  'うるさい',
  'こくもつ',
  'ちゃいろ',
  'めいずる',
  'そうしき',
  'はっこう',
  'けっさん',
  'ねんれい',
  'もちいる',
  'にげだす',
  'たてもの',
  'さいぜん',
  'かえって',
  'ばんざい',
  'はいざら',
  'おくれる',
  'こうして',
  'フォーク',
  'どくしゃ',
  'きわめて',
  'こんかい',
  'がくせつ',
  'のがれる',
  'どうぶつ',
  'うけとり',
  'かんずる',
  'ささやく',
  'アルカリ',
  'メーカー',
  'こうぜん',
  'くるしむ',
  'あかるい',
  'ビニール',
  'さいわい',
  'セックス',
  'りょかく',
  'おそわる',
  'かけざん',
  'すんぽう',
  'さつえい',
  'なんぼく',
  'あやまち',
  'しゃべる',
  'じっせき',
  'かのじょ',
  'ワープロ',
  'いっぽう',
  'げんかん',
  'ぶっしつ',
  'へいたい',
  'しょうじ',
  'ぼうぜん',
  'マラソン',
  'トラブル',
  'はっしゃ',
  'あたえる',
  'いっぱん',
  'こうちゃ',
  'じんめい',
  'うちゅう',
  'パジャマ',
  'けいしき',
  'セメント',
  'そうかん',
  'ドライブ',
  'おととい',
  'しんてん',
  'しんぱん',
  'あやふや',
  'じゅうじ',
  'おだてる',
  'めじるし',
  'すこしも',
  'どわすれ',
  'なかほど',
  'ぜんめつ',
  'せっかい',
  'ふんまつ',
  'いっぱい',
  'なるほど',
  'へだてる',
  'はっくつ',
  'みわたす',
  'めいさん',
  'ナイロン',
  'あざむく',
  'こごらす',
  'しゃれる',
  'りょけん',
  'こうどう',
  'まことに',
  'ゆうどう',
  'こうもく',
  'さんがく',
  'くつした',
  'まもなく',
  'はじめる',
  'コメント',
  'ざんこく',
  'ともなう',
  'はなやか',
  'じょうぎ',
  'もうすぐ',
  'ぐっすり',
  'デッサン',
  'としより',
  'としごろ',
  'ちょしゃ',
  'ざいさん',
  'まごつく',
  'せいげん',
  'れっとう',
  'ちんぎん',
  'はなびら',
  'くっつく',
  'はみがき',
  'ちょめい',
  'かくてい',
  'まいにち',
  'けつえき',
  'うたがう',
  'じつよう',
  'どんかん',
  'ふっこう',
  'もっぱら',
  'ばくぜん',
  'ものごと',
  'タクシー',
  'とうてい',
  'かんごし',
  'しんよう',
  'でんえん',
  'くるしい',
  'ははおや',
  'きっかけ',
  'しんごう',
  'がんしょ',
  'ぎじゅつ',
  'つづける',
  'ひとまず',
  'びじゅつ',
  'くろうと',
  'はついく',
  'ふくざつ',
  'うりきれ',
  'かなづち',
  'れんぞく',
  'けっせい',
  'ぜいたく',
  'しょもつ',
  'かいどう',
  'きんずる',
  'ほんだな',
  'なんなり',
  'ざいがく',
  'こくてい',
  'いただく',
  'かんけい',
  'かんがえ',
  'すいそう',
  'びっくり',
  'まちがい',
  'よつかど',
  'ぶんさん',
  'ひっぱる',
  'がんせき',
  'かいいん',
  'こうげい',
  'あんしん',
  'そうおう',
  'じゅわき',
  'おこなう',
  'ろうそく',
  'おおかた',
  'めいじる',
  'こんきょ',
  'えんがん',
  'ししゅつ',
  'めでたい',
  'きょうり',
  'たいする',
  'つじつま',
  'さぎょう',
  'しんじつ',
  'やっかい',
  'げっそり',
  'うちきる',
  'たのしい',
  'ぶんすう',
  'かくしん',
  'ざいげん',
  'うんめい',
  'さえぎる',
  'まるごと',
  'こしょう',
  'はんげき',
  'でくわす',
  'ちっとも',
  'いたわる',
  'おまいり',
  'せんそう',
  'いにしえ',
  'ゆうやけ',
  'さっかく',
  'ろんぶん',
  'ひやかす',
  'けんやく',
  'ゆうはん',
  'とちゅう',
  'ぶりょく',
  'こうざん',
  'しゅうじ',
  'うんざり',
  'へんかん',
  'こうどく',
  'えんかつ',
  'ふうとう',
  'ばんぐみ',
  'そっくり',
  'おうたい',
  'げつよう',
  'パターン',
  'それとも',
  'れいとう',
  'すんなり',
  'あべこべ',
  'せいほう',
  'よのなか',
  'しんらい',
  'さっぱり',
  'しょさい',
  'しっぱい',
  'せんたく',
  'みつける',
  'はんばい',
  'げんぶん',
  'ばんにん',
  'べんろん',
  'ぶんたい',
  'ばんのう',
  'なるべく',
  'おうずる',
  'せっきん',
  'どくそう',
  'けいれき',
  'すばやい',
  'けんめい',
  'ひかえる',
  'じつれい',
  'おみやげ',
  'さずける',
  'そんざい',
  'ずいひつ',
  'しずめる',
  'シリーズ',
  'かさねる',
  'やぶれる',
  'ようふう',
  'びしょう',
  'たやすい',
  'てんらく',
  'すまない',
  'ねっする',
  'オーバー',
  'ようじん',
  'おおはば',
  'スペース',
  'しかくい',
  'がっくり',
  'きにいる',
  'けっこう',
  'ちょうど',
  'きっちり',
  'こうじつ',
  'こうげき',
  'そくばく',
  'かんれき',
  'そうべつ',
  'ちょうき',
  'ちゅうわ',
  'たべもの',
  'だいきん',
  'ふるえる',
  'よくせい',
  'いじゅう',
  'あんてい',
  'しょぶん',
  'ろうじん',
  'きずつく',
  'うんよう',
  'ふかけつ',
  'ひつよう',
  'ゆうせい',
  'しゅるい',
  'かぞえる',
  'ぐうすう',
  'はさまる',
  'れんごう',
  'はんぱつ',
  'けいけん',
  'けんげん',
  'ちがえる',
  'かんれん',
  'とうろく',
  'びんかん',
  'しゅけん',
  'みなさん',
  'あずける',
  'にぎわう',
  'こうけい',
  'ネクタイ',
  'てきせつ',
  'かけあし',
  'まいあさ',
  'ずひょう',
  'りょうし',
  'じっかん',
  'かみのけ',
  'てきする',
  'せいしょ',
  'かつよう',
  'てぶくろ',
  'よろこぶ',
  'けいこく',
  'ぴったり',
  'てじゅん',
  'ともだち',
  'かいがん',
  'あんさつ',
  'ひさしい',
  'しょどう',
  'こうしき',
  'つてこと',
  'とくべつ',
  'システム',
  'きちんと',
  'ていねい',
  'つよめる',
  'すっぱい',
  'ほんらい',
  'ひょうか',
  'ぞくする',
  'まとめる',
  'しんるい',
  'やくしゃ',
  'しょうこ',
  'ばらまく',
  'むちゅう',
  'かたづく',
  'かたわら',
  'じゅつご',
  'せいれつ',
  'だいよう',
  'おいわい',
  'げんさく',
  'いくせい',
  'りょうり',
  'はんけつ',
  'こうだん',
  'ぶんれつ',
  'めいじん',
  'とくさん',
  'うえした',
  'こんごう',
  'かんかく',
  'ところが',
  'せいする',
  'おこない',
  'たいてい',
  'ふんそう',
  'ほうあん',
  'キャッチ',
  'ちょうり',
  'とぼしい',
  'のりこむ',
  'サイクル',
  'かいふく',
  'きょよう',
  'ていせい',
  'せんげつ',
  'てっぽう',
  'てっぺん',
  'ねんかん',
  'げきぞう',
  'サンプル',
  'けんきょ',
  'ほうりつ',
  'しょせき',
  'げんざい',
  'こうこく',
  'グループ',
  'ゆうめい',
  'ねまわし',
  'いちだん',
  'れいせい',
  'うめこむ',
  'こうしん',
  'せいけい',
  'せんだい',
  'れっしゃ',
  'ちりとり',
  'さいのう',
  'きんもつ',
  'ししゅう',
  'こうふん',
  'すいえい',
  'きんぞく',
  'スタイル',
  'てんきょ',
  'つっぱる',
  'たんいつ',
  'とうしょ',
  'しょうひ',
  'たいはん',
  'さんすう',
  'はったつ',
  'ビジネス',
  'つうしん',
  'さくいん',
  'モニター',
  'せいりつ',
  'やちゅう',
  'かいぞう',
  'かんげん',
  'てきかく',
  'けつぼう',
  'かわかす',
  'いたずら',
  'うそつき',
  'とりかえ',
  'もよおす',
  'けいかい',
  'こうきょ',
  'かいせつ',
  'かかわる',
  'けいさい',
  'あらゆる',
  'ゆううつ',
  'かかえる',
  'スタンド',
  'けいえい',
  'こうすい',
  'まっすぐ',
  'しゃぶる',
  'さくげん',
  'まえおき',
  'かんしゃ',
  'さんぶつ',
  'ウーマン',
  'たっする',
  'めんせつ',
  'ローマジ',
  'ずらっと',
  'ストップ',
  'しにょう',
  'あんない',
  'かたこと',
  'さむらい',
  'さしひき',
  'よごれる',
  'ろうすい',
  'つくろう',
  'はつげん',
  'うれしい',
  'だんすい',
  'ぜんてい',
  'しょざい',
  'はいじょ',
  'オレンジ',
  'ほんかく',
  'かみきる',
  'すっきり',
  'ただしい',
  'ガレージ',
  'ふりょく',
  'ハンサム',
  'こくおう',
  'ほろびる',
  'けいたい',
  'こわれる',
  'みとめる',
  'かいばつ',
  'ぜんしゃ',
  'かさばる',
  'ふんだん',
  'とっくに',
  'はっせい',
  'ナンバー',
  'そんとく',
  'だんかい',
  'ぼうどう',
  'とりけす',
  'マフラー',
  'きんがん',
  'とっきょ',
  'ささえる',
  'けっせき',
  'ふじゆう',
  'もうかる',
  'ごうせい',
  'かんぜん',
  'めんぜい',
  'てんこう',
  'ローンチ',
  'こちょう',
  'ゆうせん',
  'ことづて',
  'ごちそう',
  'おおがら',
  'でんせつ',
  'シナリオ',
  'おうえん',
  'せいせき',
  'ぎょうむ',
  'きんよう',
  'つっこむ',
  'しつこい',
  'じんぞう',
  'ぞんずる',
  'サンダル',
  'よびだす',
  'かいたく',
  'おもなる',
  'きんがく',
  'はたらき',
  'だんぼう',
  'こんざつ',
  'チェンジ',
  'ばんごう',
  'とどめる',
  'ショップ',
  'かんさい',
  'じゅくご',
  'ずいぶん',
  'カセット',
  'いもうと',
  'ものさし',
  'とうせん',
  'たたかい',
  'へいきん',
  'まいばん',
  'がくれき',
  'ふけいき',
  'かしこい',
  'ぼうせき',
  'べんとう',
  'はんぶん',
  'しょめい',
  'せいこう',
  'さまざま',
  'きんじる',
  'たいきん',
  'だんげん',
  'あつかい',
  'ほしもの',
  'しくじる',
  'とうこう',
  'カクテル',
  'かいかく',
  'のきなみ',
  'せっけい',
  'あわてる',
  'まばたき',
  'きよらか',
  'こうそう',
  'しらべる',
  'とがめる',
  'ぼうさん',
  'いまにも',
  'おそれる',
  'せっする',
  'きょうみ',
  'ひいては',
  'しんけい',
  'おもいで',
  'れんそう',
  'きんえん',
  'じゅんさ',
  'かにゅう',
  'へんとう',
  'じんるい',
  'すこやか',
  'そくてい',
  'インフレ',
  'ぶんぱい',
  'スポーツ',
  'かんせつ',
  'ふさがる',
  'のっとる',
  'だいたん',
  'いけばな',
  'かんけつ',
  'しっぴつ',
  'せいよう',
  'よくあつ',
  'じょせい',
  'まとまる',
  'しんさつ',
  'けんせつ',
  'かっぱつ',
  'わくせい',
  'メニュー',
  'せいしき',
  'どくりつ',
  'つぶれる',
  'ベテラン',
  'まんいん',
  'げんけい',
  'くんしゅ',
  'ごくらく',
  'たたかう',
  'おおげさ',
  'ないよう',
  'とうざい',
  'ちっそく',
  'むかえる',
  'とうろん',
  'ふっとう',
  'ごぞんじ',
  'しまった',
  'がいせつ',
  'はじらう',
  'たまわる',
  'みおとす',
  'オープン',
  'いくぶん',
  'おこたる',
  'ファイル',
  'らいげつ',
  'おおみず',
  'きまぐれ',
  'じんみん',
  'こうじょ',
  'さいけん',
  'はいぶん',
  'ぶんけん',
  'ことがら',
  'たんとう',
  'みじゅく',
  'かいがい',
  'えつらん',
  'わすれる',
  'じょこう',
  'ひんこん',
  'きゅうか',
  'てきとう',
  'こっせつ',
  'いっぺん',
  'こうぞう',
  'ひきわけ',
  'ゆうじん',
  'とりわけ',
  'せんきょ',
  'えいよう',
  'ほんかん',
  'ちらっと',
  'およぼす',
  'ただちに',
  'ぼうはん',
  'みつもり',
  'おうふく',
  'みおろす',
  'アイデア',
  'かじょう',
  'へいほう',
  'かちょう',
  'スケート',
  'おんがく',
  'えんじる',
  'だいなし',
  'かけっこ',
  'かんてん',
  'つながり',
  'はくしゅ',
  'やくそく',
  'ほんとう',
  'かいとう',
  'せいじつ',
  'たんぺん',
  'さくせん',
  'かがやく',
  'うけつぐ',
  'おかわり',
  'てじょう',
  'あやしい',
  'げんかい',
  'てんきん',
  'ふたたび',
  'ほっそく',
  'おそらく',
  'あらそう',
  'なんとも',
  'うんえい',
  'こうがい',
  'たいかく',
  'ふりだし',
  'さかさま',
  'ちきゅう',
  'けいげん',
  'けっこん',
  'とくてい',
  'したまち',
  'がっぺい',
  'しゅだい',
  'おくらす',
  'あんじる',
  'ころがる',
  'いじわる',
  'さびしい',
  'せいさく',
  'みなもと',
  'おんけい',
  'ちゅうい',
  'しょうち',
  'かくだい',
  'つらねる',
  'いんきょ',
  'ねかせる',
  'ぎんこう',
  'そのころ',
  'ふくらむ',
  'かくじつ',
  'できもの',
  'よふかし',
  'かんじる',
  'だいじん',
  'うんそう',
  'はぐるま',
  'たかまる',
  'メーター',
  'うらぎる',
  'どんぶり',
  'ぞんじる',
  'てんせん',
  'せんでん',
  'とつぜん',
  'くうそう',
  'あっぱく',
  'せいぞん',
  'かんせい',
  'ぜんいん',
  'うけつけ',
  'こぼれる',
  'しゅくが',
  'まんぞく',
  'そうなん',
  'がんねん',
  'メディア',
  'せいさん',
  'ぐうぜん',
  'すいみん',
  'とうさん',
  'げじゅん',
  'ゆるやか',
  'かなえる',
  'だいべん',
  'かつやく',
  'デザイン',
  'まちがう',
  'がいとう',
  'ゆうのう',
  'えんぽう',
  'しょばつ',
  'しなやか',
  'ほんしつ',
  'じんぶつ',
  'じょうほ',
  'せいけん',
  'まぶしい',
  'ものおき',
  'めんする',
  'あけがた',
  'ひのまる',
  'げんろん',
  'さくじょ',
  'がいねん',
  'オッケー',
  'センター',
  'しょっき',
  'こうたい',
  'ぶつける',
  'じったい',
  'ほんもの',
  'ちんもく',
  'すきずき',
  'なにぶん',
  'いじめる',
  'しばらく',
  'ふんいき',
  'たすける',
  'コーラス',
  'くうふく',
  'あわせる',
  'たとえる',
  'さつじん',
  'おやすみ',
  'ふっかつ',
  'アパート',
  'くじびき',
  'きかざる',
  'どうふう',
  'サイレン',
  'とけこむ',
  'ねっしん',
  'こんばん',
  'ともかく',
  'デザート',
  'ゆうがた',
  'だいほん',
  'ひとしい',
  'こんどう',
  'もたらす',
  'ほうがく',
  'しなびる',
  'はいしゃ',
  'こうしゃ',
  'うかがう',
  'だんぜん',
  'じぎょう',
  'いいわけ',
  'ばってん',
  'せんせい',
  'あつかう',
  'ぶんめい',
  'ひょうし',
  'ひところ',
  'らいねん',
  'ポスター',
  'ちゃのま',
  'まんまえ',
  'わりざん',
  'じんじゃ',
  'きみょう',
  'せっかく',
  'はりがね',
  'ちゃのゆ',
  'まったく',
  'ほとんど',
  'ほうてい',
  'てってい',
  'しりぞく',
  'さくもつ',
  'がっしり',
  'ほうしん',
  'パトカー',
  'かいてん',
  'はかどる',
  'レディー',
  'スピーチ',
  'たちかた',
  'けつあつ',
  'それぞれ',
  'かんさつ',
  'どくせん',
  'いちげん',
  'らくだい',
  'とうとい',
  'あんがい',
  'じょうふ',
  'はんざい',
  'ほがらか',
  'おもたい',
  'じじょう',
  'うらやむ',
  'ようがん',
  'すませる',
  'しつぼう',
  'いったい',
  'げんぞう',
  'ざんだか',
  'じゅけん',
  'けんぶつ',
  'アルバム',
  'こづつみ',
  'かくべつ',
  'やしなう',
  'かそくど',
  'げいのう',
  'ふくめん',
  'レッスン',
  'ぼうけん',
  'せんさい',
  'こうにん',
  'あれこれ',
  'いきがい',
  'じょうず',
  'ぜんこく',
  'ステレオ',
  'さしひく',
  'そくざに',
  'せつやく',
  'せいぞう',
  'ぎじどう',
  'へんけん',
  'おしゃれ',
  'そんけい',
  'ほうかい',
  'こうせき',
  'テキスト',
  'のみこむ',
  'ちいさい',
  'げんそく',
  'ことわざ',
  'かくめい',
  'まいすう',
  'まじわる',
  'じょうか',
  'こうせん',
  'たんすう',
  'らんよう',
  'ぜんかい',
  'てがける',
  'ギャング',
  'ひとつき',
  'すいへい',
  'かかげる',
  'ひろまる',
  'せっけん',
  'じんせい',
  'とうせい',
  'にくしみ',
  'ほきゅう',
  'かいけつ',
  'せいしつ',
  'あとつぎ',
  'いっせい',
  'メンバー',
  'フィルム',
  'するどい',
  'だきょう',
  'せいじん',
  'しつもん',
  'じゅうし',
  'でたらめ',
  'せっせと',
  'ろんじる',
  'たすかる',
  'せいしん',
  'ついほう',
  'ついやす',
  'しゅさい',
  'ゆうだち',
  'したしい',
  'しょてい',
  'もちろん',
  'ウイルス',
  'かんぜい',
  'ひこうき',
  'おでかけ',
  'さくせい',
  'めざまし',
  'フロント',
  'ごうとう',
  'つうじる',
  'らくのう',
  'きちっと',
  'アクセル',
  'たいがい',
  'ぎきょく',
  'せんしゅ',
  'じどうし',
  'しはらう',
  'なめらか',
  'れいてん',
  'ちゃわん',
  'ダイヤル',
  'てつだい',
  'えきたい',
  'いちばん',
  'もんだい',
  'ぜんしん',
  'てんけい',
  'めいろう',
  'またがる',
  'せきどう',
  'たっせい',
  'こいしい',
  'かきとり',
  'しゃこう',
  'うりだす',
  'くしゃみ',
  'くちべに',
  'サークル',
  'かいうん',
  'しっかく',
  'しあわせ',
  'しんけん',
  'カロリー',
  'みだれる',
  'ごういん',
  'まとまり',
  'ちゅうし',
  'ていねん',
  'かわいい',
  'もしくは',
  'ポイント',
  'ちょうめ',
  'おうせつ',
  'かならず',
  'どうとう',
  'おぼえる',
  'たいりく',
  'はいゆう',
  'げんきん',
  'クリーム',
  'つうやく',
  'ちぢれる',
  'こうけん',
  'けいとう',
  'めんどう',
  'ようそう',
  'ばいきん',
  'てあらい',
  'てんたい',
  'ゆるめる',
  'かいはつ',
  'どうかん',
  'ちかぢか',
  'しんがく',
  'トランプ',
  'ほしょう',
  'そのまま',
  'テーブル',
  'つかまる',
  'みなおす',
  'しんこう',
  'したどり',
  'ちょくご',
  'えんせん',
  'ぶっそう',
  'あやまり',
  'はりがみ',
  'てんじる',
  'せいぜん',
  'いねむり',
  'てんかい',
  'えいえん',
  'たいかい',
  'しょるい',
  'まっくら',
  'つうずる',
  'ききとり',
  'せいぶつ',
  'ひっこむ',
  'ゆっくり',
  'えんげき',
  'チャイム',
  'けっさく',
  'うるおう',
  'しゃらく',
  'けつだん',
  'しゅやく',
  'まんてん',
  'さしだす',
  'おちつき',
  'それほど',
  'たどうし',
  'かたがた',
  'すうがく',
  'くちびる',
  'とこのま',
  'しきりに',
  'かいすう',
  'キャリア',
  'すいぶん',
  'はたして',
  'たいめん',
  'ぞうきん',
  'まずしい',
  'しんじる',
  'はやくち',
  'ほんにん',
  'かくにん',
  'こうてい',
  'しんそう',
  'こっかい',
  'どひょう',
  'でんらい',
  'さいしょ',
  'とくゆう',
  'ようもう',
  'おろそか',
  'ナイター',
  'ゆびさす',
  'あつめる',
  'ゆうわく',
  'ゆうびん',
  'でんせん',
  'かいけい',
  'こうかん',
  'ぶんげい',
  'はたらく',
  'わかれる',
  'ねんせい',
  'どくさい',
  'まじえる',
  'こくばん',
  'そのうえ',
  'のこらず',
  'おどろく',
  'さくぶつ',
  'いったん',
  'じっこう',
  'かんとう',
  'さいよう',
  'しあがり',
  'しんくう',
  'のこぎり',
  'ちょうわ',
  'とりひき',
  'しょくじ',
  'むじゅん',
  'はっけん',
  'さいそく',
  'さいきん',
  'ふんがい',
  'はつおん',
  'アンテナ',
  'あるいは',
  'まっくろ',
  'ばいてん',
  'ていぼう',
  'ぼんやり',
  'とうたつ',
  'じゃぐち',
  'かいせい',
  'あざやか',
  'おうだん',
  'こなごな',
  'さいばん',
  'すいさん',
  'すたれる',
  'みじかい',
  'しょうみ',
  'むりょう',
  'たいへん',
  'いやしい',
  'のんびり',
  'あぶらえ',
  'そうごう',
  'みはらし',
  'うんてん',
  'ざつおん',
  'えんぴつ',
  'みかける',
  'とりにく',
  'ふくすう',
  'しじゅう',
  'トンネル',
  'かなしい',
  'あずかる',
  'やくしょ',
  'けしょう',
  'でんぽう',
  'けいぞく',
  'ろんそう',
  'ておくれ',
  'ポケット',
  'けってん',
  'こくりつ',
  'なるたけ',
  'こづかい',
  'おりもの',
  'はんのう',
  'スプーン',
  'コーナー',
  'じんしゅ',
  'ビタミン',
  'えんとつ',
  'ためらう',
  'あらすじ',
  'おぎなう',
  'つながる',
  'にくたい',
  'いわゆる',
  'せっとく',
  'こうぶつ',
  'どうやら',
  'あらわれ',
  'いきおい',
  'スライド',
  'しんせい',
  'こんなに',
  'あじわう',
  'こうばい',
  'せいだく',
  'せつじつ',
  'あちこち',
  'くださる',
  'しんぼう',
  'ようてん',
  'せいべつ',
  'てぬぐい',
  'えいゆう',
  'きいろい',
  'けんかい',
  'つたわる',
  'ぐんたい',
  'げんこう',
  'しんりん',
  'そうどう',
  'レポート',
  'くわしい',
  'でこぼこ',
  'ぼくちく',
  'のうこう',
  'しみじみ',
  'かいらん',
  'いちどう',
  'へんかく',
  'たんけん',
  'ないりく',
  'おどろき',
  'こうとう',
  'らっかん',
  'ねんりん',
  'ひきとる',
  'せいれき',
  'きゅうに',
  'せんこう',
  'ゆうこう',
  'すうはい',
  'ラジカセ',
  'じっさい',
  'ふりだす',
  'がいかん',
  'うんどう',
  'あまくち',
  'かさなる',
  'なまける',
  'つつしむ',
  'しょぞく',
  'クレーン',
  'とらえる',
  'セーター',
  'ときどき',
  'まにあう',
  'みおくり',
  'くっせつ',
  'はじまり',
  'かおつき',
  'ジャンプ',
  'とうそつ',
  'そのため',
  'こうりょ',
  'ジュース',
  'おびえる',
  'せいかつ',
  'くずれる',
  'ひろがる',
  'ちやほや',
  'がいこう',
  'すいでん',
  'みりょく',
  'どろぼう',
  'すいとう',
  'こっそり',
  'ぎょそん',
  'きんろう',
  'ばったり',
  'おみまい',
  'きびしい',
  'こうえき',
  'にんげん',
  'こしかけ',
  'ぜんぱん',
  'そくたつ',
  'かんゆう',
  'しんじゅ',
  'かみさま',
  'けっかん',
  'ユーモア',
  'カーテン',
  'ことわる',
  'かんげき',
  'きょだい',
  'ふかまる',
  'でんしゃ',
  'きまじめ',
  'きんべん',
  'くんれん',
  'そくする',
  'そしょう',
  'ことなる',
  'ふうぞく',
  'かんがい',
  'ナプキン',
  'ふざける',
  'つきあい',
  'よわめる',
  'ふきそく',
  'いんかん',
  'にんしき',
  'あらわす',
  'デパート',
  'わがまま',
  'せんとう',
  'けいこう',
  'おうさま',
  'さからう',
  'ずぶぬれ',
  'はんにん',
  'こくせき',
  'きたない',
  'それから',
  'なにとぞ',
  'こないだ',
  'ほろぼす',
  'みせもの',
  'すいせん',
  'じょゆう',
  'いっそう',
  'わりこむ',
  'パソコン',
  'てのひら',
  'げんじつ',
  'つとめて',
  'ちんれつ',
  'とぎれる',
  'もとづく',
  'よしあし',
  'ハンカチ',
  'ブレーキ',
  'せきにん',
  'しょうゆ',
  'むらさき',
  'なまいき',
  'てつがく',
  'しはらい',
  'はいたつ',
  'スタジオ',
  'はげます',
  'キャンプ',
  'がいろん',
  'マスコミ',
  'こうばん',
  'かんどう',
  'いちよう',
  'おしこむ',
  'けいかく',
  'マイナス',
  'ほうずる',
  'おんせん',
  'よろしく',
  'インテリ',
  'じゅよう',
  'ようとう',
  'おさえる',
  'マスター',
  'おおすじ',
  'けんよう',
  'ラケット',
  'すすめる',
  'ちかてつ',
  'たんどく',
  'とうばん',
  'れいがい',
  'けとばす',
  'しきたり',
  'ひるめし',
  'チャネル',
  'みとおし',
  'となえる',
  'けっしん',
  'どんなに',
  'こころみ',
  'こくさい',
  'いんたい',
  'ストロー',
  'はちみつ',
  'みつかる',
  'ごうかく',
  'うんぱん',
  'ざつだん',
  'シャワー',
  'みんよう',
  'さいなん',
  'ざいせい',
  'はんだん',
  'おはよう',
  'パーティ',
  'ひきいる',
  'ちょきん',
  'どくしょ',
  'こういん',
  'ちんでん',
  'しゃりん',
  'トラック',
  'やくひん',
  'ですから',
  'こくみん',
  'ちょっと',
  'てきおう',
  'くうこう',
  'どうにか',
  'もくてき',
  'じょがい',
  'はりきる',
  'じっけん',
  'はいせん',
  'さだまる',
  'むなしい',
  'せいけつ',
  'べっそう',
  'でんたつ',
  'あらそい',
  'しゅうき',
  'ふんすい',
  'ぶんがく',
  'いちにち',
  'げきだん',
  'しゅうい',
  'しめきり',
  'ぶつかる',
  'せんすい',
  'たいせん',
  'ゆうれい',
  'かまえる',
  'すっかり',
  'つまずく',
  'あきれる',
  'くみあい',
  'おやゆび',
  'ざんきん',
  'おだやか',
  'たちよる',
  'てっこう',
  'ちゅうこ',
  'せいふく',
  'たいさく',
  'おしいれ',
  'みんしゅ',
  'ショック',
  'かねぐら',
  'はじめて',
  'おじさん',
  'よしゅう',
  'あくまで',
  'チョーク',
  'つたえる',
  'ブラウス',
  'そのほか',
  'はじめに',
  'つりかわ',
  'レジャー',
  'はつみみ',
  'ふんとう',
  'ようぼう',
  'きっぱり',
  'おとうと',
  'なぜなら',
  'だいすき',
  'おうじょ',
  'つりがね',
  'しょみん',
  'ひとじち',
  'あふれる',
  'せともの',
  'びんづめ',
  'きんせん',
  'オフィス',
  'もちきり',
  'めったに',
  'げんばく',
  'たいふう',
  'しゅざい',
  'おたがい',
  'てんのう',
  'きょうか',
  'こっこう',
  'よくばり',
  'うすめる',
  'かんこう',
  'ととのう',
  'かいぼう',
  'しきゅう',
  'からっぽ',
  'かんげい',
  'みにくい',
  'いちどに',
  'しょはん',
  'うやまう',
  'ほうげん',
  'のみもの',
  'みずうみ',
  'ぎょうじ',
  'はかない',
  'こうへい',
  'けつごう',
  'あくどい',
  'しゅほう',
  'はんこう',
  'のうそん',
  'はんせい',
  'やくにん',
  'ないぞう',
  'せんぱい',
  'コンパス',
  'ステーキ',
  'たのしむ',
  'ソックス',
  'おおやけ',
  'もうてん',
  'できごと',
  'うちけす',
  'はなよめ',
  'ころがす',
  'ないかく',
  'はっきり',
  'イコール',
  'ゆうえき',
  'きんぎょ',
  'ほうこう',
  'けいさん',
  'たいよう',
  'うんちん',
  'はなはだ',
  'どようび',
  'うらなう',
  'スチーム',
  'とだえる',
  'いつでも',
  'さいてい',
  'とくばい',
  'けいべつ',
  'それでも',
  'かんそく',
  'しりあい',
  'どういつ',
  'かんたん',
  'げんさん',
  'おおいに',
  'ぎちょう',
  'こまやか',
  'じんたい',
  'いんよう',
  'てつどう',
  'けつろん',
  'おうじる',
  'ジーパン',
  'めいわく',
  'めいしょ',
  'とどける',
  'ぜつぼう',
  'めざめる',
  'あからむ',
  'はんする',
  'ふしょう',
  'ふろしき',
  'せいとう',
  'えんまん',
  'ください',
  'あくしゅ',
  'えんそう',
  'みなれる',
  'めんかい',
  'じょうし',
  'つきあう',
  'しょくむ',
  'ぜったい',
  'たんしょ',
  'そうこう',
  'スイッチ',
  'さんばし',
  'らいてん',
  'いっぷう',
  'せいおん',
  'ねんない',
  'けいしん',
  'いろんな',
  'ゆゆしい',
  'みんせい',
  'けいちつ',
  'かくれが',
  'じゅれい',
  'よみうり',
  'なまもの',
  'グリーン',
  'らんがい',
  'うりもの',
  'ききだす',
  'おもかげ',
  'かいえん',
  'けいすう',
  'しらいと',
  'たんまつ',
  'ぜつえん',
  'ようへい',
  'かんのん',
  'きんぎん',
  'どんよく',
  'ばいぞう',
  'りっこく',
  'はやぶさ',
  'くびきり',
  'しゃおく',
  'おうとう',
  'ほんけん',
  'ほんこう',
  'どちゃく',
  'むしょく',
  'いえがら',
  'てんどん',
  'しゅくん',
  'ぶっとう',
  'せんばん',
  'しゅにん',
  'あっとう',
  'けんこく',
  'うちわけ',
  'えんらい',
  'ぜんぽう',
  'ずいしょ',
  'うろつく',
  'しんがお',
  'きごころ',
  'じゅんい',
  'みずから',
  'じんよう',
  'ばんねん',
  'とくする',
  'ようふぼ',
  'きょだく',
  'ばんこう',
  'めいひん',
  'あしどめ',
  'かいじん',
  'なのはな',
  'どくさつ',
  'おせいぼ',
  'こうごう',
  'けっせん',
  'ひきぬく',
  'しんでん',
  'ないじゅ',
  'あまもり',
  'わんぱく',
  'うちがけ',
  'はくねつ',
  'きょうよ',
  'よこなみ',
  'かねもち',
  'きんげん',
  'おうだく',
  'むくいる',
  'はつえん',
  'ようがく',
  'かわしも',
  'めいだい',
  'ないしん',
  'うきよえ',
  'まきぞえ',
  'ざいにん',
  'こうだい',
  'おんよみ',
  'しろくろ',
  'かんめい',
  'そうぜつ',
  'こっとう',
  'つけたす',
  'ぼうそう',
  'ろうごく',
  'しょうき',
  'はりあう',
  'じゅうき',
  'そこぬけ',
  'まんざら',
  'ばっそく',
  'せばめる',
  'かっぽう',
  'とうかく',
  'ただよう',
  'しゅとく',
  'こっかく',
  'のみくい',
  'ひとざと',
  'おいたて',
  'ひやかし',
  'せきずい',
  'だいしょ',
  'そんする',
  'じんまく',
  'かんぷう',
  'いむしつ',
  'せっしゅ',
  'あだうち',
  'ちゃくい',
  'せいいき',
  'とうえい',
  'きんぴん',
  'いんめつ',
  'つぐなう',
  'じゅうに',
  'からあげ',
  'おしうり',
  'とりあう',
  'ききざけ',
  'ないだく',
  'けんえつ',
  'へんきん',
  'しょうに',
  'おひらき',
  'いっかく',
  'こんかん',
  'はいきん',
  'まじわり',
  'まるがり',
  'もぎてん',
  'びんわん',
  'ぜんしょ',
  'そうあい',
  'ぎょらい',
  'むきぶつ',
  'さんけい',
  'うりょう',
  'ぞくらく',
  'なわばり',
  'ゆうがく',
  'りんばん',
  'れいえん',
  'さっしん',
  'しんぴん',
  'あんばい',
  'ゆうぎり',
  'ほんどう',
  'ぼっとう',
  'そんりつ',
  'きたがわ',
  'いちえん',
  'きょらい',
  'どうざん',
  'ついぜん',
  'しちさん',
  'せきざい',
  'ほんごく',
  'ばんこく',
  'しんげん',
  'あさはか',
  'きちがい',
  'ふうぜん',
  'まちぶせ',
  'はくぎん',
  'れいこん',
  'げんたん',
  'にちろく',
  'さきごろ',
  'みなおし',
  'こうれい',
  'べんめい',
  'つうせい',
  'ぼくしょ',
  'どうばん',
  'らいごう',
  'はりだし',
  'おうよう',
  'ほんよみ',
  'イメージ',
  'にんまえ',
  'おきなわ',
  'いんそつ',
  'えいかく',
  'きかんし',
  'れっせい',
  'がんぜん',
  'あおむけ',
  'ていでん',
  'あっせい',
  'しゅっけ',
  'ぜつだい',
  'えんじん',
  'さかみち',
  'はなみず',
  'くるしみ',
  'おそざき',
  'しょさん',
  'ほんだい',
  'こうでん',
  'ちゃくざ',
  'がいかい',
  'げんちょ',
  'ほうげき',
  'ぶきょく',
  'ききとる',
  'まちあい',
  'きょうど',
  'きんせき',
  'しとめる',
  'りんけん',
  'しらくも',
  'ちゅうじ',
  'なみうつ',
  'あけくれ',
  'さくねん',
  'としのせ',
  'はっけい',
  'ぶんぴつ',
  'ぼうぎょ',
  'いろがら',
  'くいこむ',
  'だいにん',
  'くちさき',
  'うわむく',
  'せいうん',
  'がんゆう',
  'ふなたび',
  'れきだい',
  'けつぜん',
  'ていせつ',
  'ほんめい',
  'つきがた',
  'しまりや',
  'ずいこう',
  'ねっから',
  'ふようい',
  'がんりき',
  'きんぱつ',
  'とうげい',
  'つりいと',
  'まつかぜ',
  'おしきり',
  'とりょう',
  'かいとり',
  'みそしる',
  'しつかん',
  'いっする',
  'くにぐに',
  'やくどう',
  'うちあげ',
  'かっそう',
  'らんせい',
  'かりとる',
  'しょうび',
  'どうるい',
  'ぼだいじ',
  'さんこつ',
  'みしゅう',
  'ひっけい',
  'しおどき',
  'ゆうもう',
  'ふきゅう',
  'おういん',
  'せんもん',
  'せんれい',
  'はくぶつ',
  'くうきょ',
  'しょうど',
  'しんけつ',
  'やくぶつ',
  'せいがく',
  'うんせい',
  'ほんせき',
  'ふみこむ',
  'しんちく',
  'たいろう',
  'たくせん',
  'やくどし',
  'ふくよう',
  'たんざく',
  'てあつい',
  'えいりん',
  'こくろん',
  'ほうちく',
  'きたむき',
  'こうちく',
  'おんしゃ',
  'はいにん',
  'そんげん',
  'きっぽう',
  'はんれい',
  'ふるびる',
  'なつくさ',
  'ないくう',
  'もうしん',
  'しんちょ',
  'りきせん',
  'めいやく',
  'せんぼう',
  'にんずう',
  'いばしょ',
  'ほうだん',
  'にょらい',
  'せきぞう',
  'おさなご',
  'こくひん',
  'かんやく',
  'とりもの',
  'よくそう',
  'めいもく',
  'へんしん',
  'こきょう',
  'あいじん',
  'さきやす',
  'しゃでん',
  'なみいる',
  'そうじゅ',
  'だいけい',
  'うちのり',
  'かいして',
  'けつらく',
  'ほんねん',
  'とくしつ',
  'はつゆめ',
  'いどみず',
  'たいりん',
  'たんさく',
  'ふかしん',
  'いまごろ',
  'てはじめ',
  'ふみだい',
  'かくげつ',
  'とうしゅ',
  'おやもと',
  'かくぜつ',
  'そうらん',
  'めいもん',
  'ほねぐみ',
  'かんそん',
  'やきばた',
  'やつれる',
  'かがくし',
  'ゆりかご',
  'ねつえん',
  'そうでん',
  'みぎはし',
  'つんどく',
  'げきちん',
  'すいけい',
  'かりぬし',
  'うらがね',
  'すいばく',
  'いっぽん',
  'ほうかご',
  'くうどう',
  'たんそく',
  'ぜんにん',
  'たいはい',
  'くうぐん',
  'ふきだす',
  'くろぼし',
  'はこいり',
  'べっしゅ',
  'かいちく',
  'めいかい',
  'たわむれ',
  'たてわり',
  'ちゅうぎ',
  'しょかい',
  'みとりず',
  'あらまき',
  'たいとう',
  'とびたつ',
  'そうしゃ',
  'あとおい',
  'たなばた',
  'よろめく',
  'たんせき',
  'しぎょう',
  'ばんぶつ',
  'やまぐに',
  'なんばん',
  'たばねる',
  'ふかめる',
  'きねんび',
  'てんぷら',
  'ようしゅ',
  'うえつけ',
  'しょうし',
  'きょこく',
  'しょけん',
  'けいぼう',
  'なきがら',
  'ざんぱん',
  'こうしょ',
  'はっさん',
  'つりあい',
  'たいしつ',
  'かんぷく',
  'よこぐみ',
  'こくぜい',
  'よくあさ',
  'あくじょ',
  'がりゅう',
  'けんみん',
  'もくぜん',
  'だいとく',
  'へんちょ',
  'うきでる',
  'いっすん',
  'にくるい',
  'ふうこう',
  'いいかた',
  'きたぐち',
  'ふしまつ',
  'こうしつ',
  'きょうそ',
  'ふくはい',
  'てばなす',
  'としよる',
  'そうとく',
  'はつもの',
  'そっこく',
  'きっすい',
  'れんさく',
  'ばんさく',
  'じょせき',
  'あかつき',
  'まつえい',
  'だいやく',
  'しひょう',
  'さいはん',
  'たれまく',
  'たいがん',
  'けんすい',
  'けんあん',
  'くらしき',
  'ぼしゅう',
  'さんらん',
  'かくやす',
  'さかいめ',
  'れいきん',
  'ざっきょ',
  'らくたん',
  'きづかい',
  'さいだい',
  'じゅうい',
  'さいまつ',
  'かいこく',
  'わくがい',
  'おろしね',
  'おくさま',
  'くちきり',
  'いんしつ',
  'はっしん',
  'さいあい',
  'てんしん',
  'じょうど',
  'くろしお',
  'うちがわ',
  'ほうにち',
  'じがぞう',
  'うかれる',
  'じっしつ',
  'ふきこむ',
  'みうける',
  'うたいて',
  'とびおり',
  'みごたえ',
  'まるごし',
  'あらごと',
  'れきてい',
  'かいやく',
  'こがらし',
  'ほりかわ',
  'それなら',
  'しなぎれ',
  'こきざみ',
  'いちぞん',
  'ちゃづけ',
  'はくあい',
  'えいだん',
  'じんぼう',
  'ほんごし',
  'やまぶき',
  'へんじん',
  'がいけい',
  'えんにち',
  'おりこむ',
  'きりょく',
  'うんすい',
  'とうてつ',
  'はなむこ',
  'きゅうふ',
  'こうにち',
  'かわばた',
  'じょしつ',
  'きめだま',
  'ぞうしん',
  'じぎゃく',
  'なにもの',
  'ぶんあん',
  'のみみず',
  'しゅべつ',
  'りゅうさ',
  'せっぷん',
  'すいしゃ',
  'ぎょぐん',
  'つけもの',
  'わんがん',
  'とうるい',
  'あいせつ',
  'せいがん',
  'いいきる',
  'ぞんぶん',
  'かくまく',
  'つみこみ',
  'あまだれ',
  'ギョーザ',
  'しゅどう',
  'みつばい',
  'くうせき',
  'ひともじ',
  'おにぎり',
  'へいせつ',
  'さいじき',
  'ふっきん',
  'あながち',
  'かんのう',
  'りふじん',
  'そうすう',
  'かきいれ',
  'まいせつ',
  'とうけつ',
  'りくぐん',
  'たいおう',
  'へいさつ',
  'ミックス',
  'たいべい',
  'るいけい',
  'やきもち',
  'じついん',
  'たくえつ',
  'かいこう',
  'じょうび',
  'へいざん',
  'とりけし',
  'たいえき',
  'まなつび',
  'ふりこむ',
  'ゆうばく',
  'くいいる',
  'ほうせい',
  'にないて',
  'しりょう',
  'もうひつ',
  'しょけい',
  'とうしゃ',
  'へいぜん',
  'はんぷく',
  'ほんきょ',
  'ろうのう',
  'かみだな',
  'かんべつ',
  'どうすう',
  'だしきる',
  'だいそつ',
  'どくせい',
  'せいらい',
  'ぎんぱい',
  'けいれい',
  'さんぱつ',
  'おしだす',
  'じょきょ',
  'いちじん',
  'どうしゃ',
  'いちなん',
  'みつめる',
  'てんにょ',
  'ざいしつ',
  'かしょく',
  'つうねん',
  'ちょうぼ',
  'りゅうか',
  'しゅっぴ',
  'くろずむ',
  'おんてん',
  'みみうち',
  'くみたて',
  'ほうせつ',
  'かりゅう',
  'ほねぶと',
  'げきれつ',
  'じきょく',
  'もんがい',
  'おしこみ',
  'えんだい',
  'さいしき',
  'けんない',
  'さずかる',
  'なかがい',
  'きねんひ',
  'かんぐん',
  'ねんぶつ',
  'なんにも',
  'さんしゃ',
  'まんきつ',
  'しゅはん',
  'いくしゅ',
  'うみどり',
  'うみやま',
  'さくしゅ',
  'ふきょう',
  'ぼうえん',
  'ふくしょ',
  'ほうしき',
  'ごうせつ',
  'ひさびさ',
  'こくべつ',
  'かいつけ',
  'はいぜつ',
  'しらはた',
  'ろんてん',
  'みつげつ',
  'ゆさぶる',
  'きさらぎ',
  'うちだし',
  'ようゆう',
  'もっかん',
  'なりたち',
  'はいそう',
  'ラグビー',
  'とうごく',
  'きんぺん',
  'ひばしら',
  'じむかん',
  'しっそく',
  'ぼうせん',
  'ふうしゃ',
  'せつでん',
  'あきかぜ',
  'まんねん',
  'かいたい',
  'ゆうごう',
  'したあじ',
  'かくさく',
  'よびこむ',
  'はやおき',
  'しっぽう',
  'しょよう',
  'たたずむ',
  'げんしん',
  'につまる',
  'ささやか',
  'よびすて',
  'おくそこ',
  'ちゅうか',
  'めんぜん',
  'しゅごう',
  'なえどこ',
  'いろずり',
  'こおどり',
  'とうかい',
  'さおとめ',
  'ぼうろん',
  'たいこく',
  'ちくぞう',
  'じつがい',
  'でんじは',
  'ひあがる',
  'わりまし',
  'くうしゃ',
  'でんこう',
  'おんしん',
  'はぐれる',
  'さくふう',
  'せっそう',
  'ちらばる',
  'いまふう',
  'おびふう',
  'ねつべん',
  'ふきげん',
  'もうじん',
  'みはらい',
  'はりだす',
  'たにぞこ',
  'ねばりけ',
  'めいゆう',
  'いちづけ',
  'あしこし',
  'さけのみ',
  'ごくあく',
  'ぞうとう',
  'おんなで',
  'とうはつ',
  'ふめいよ',
  'にうごき',
  'くうれい',
  'がんばり',
  'かたより',
  'しんとう',
  'そうかつ',
  'したくさ',
  'あおやぎ',
  'はくせん',
  'うえこみ',
  'ようねん',
  'つねづね',
  'いりょく',
  'ねんまつ',
  'あびせる',
  'せじょう',
  'ふなばし',
  'ちんつう',
  'けんてい',
  'ぶじょく',
  'おきもの',
  'きんりん',
  'こころね',
  'らんぱく',
  'はんえん',
  'じゅりつ',
  'のりおり',
  'はんめい',
  'せいゆう',
  'みずとり',
  'なにびと',
  'ひょうぎ',
  'おとずれ',
  'ゆうすい',
  'がんかい',
  'いちもつ',
  'ちょうじ',
  'きょうち',
  'ついしん',
  'やすらぐ',
  'こくどう',
  'くいもの',
  'たちうち',
  'ほっこう',
  'たいざい',
  'よじょう',
  'ひえきる',
  'てんらん',
  'くろまつ',
  'てんしゅ',
  'げつない',
  'きょぼく',
  'あきびん',
  'あげしお',
  'べいこく',
  'たんぼう',
  'がんたん',
  'たんれん',
  'にくだん',
  'きりさげ',
  'とうぼく',
  'まんぷく',
  'こんせき',
  'けんがい',
  'うりこむ',
  'へんれい',
  'いっすい',
  'ふゆもの',
  'たいがく',
  'りっとう',
  'れきほう',
  'せいだん',
  'しんそつ',
  'こうしゅ',
  'ぼんたい',
  'るいする',
  'かいさく',
  'ばんちゃ',
  'せいかん',
  'のっかる',
  'つきでる',
  'げんたい',
  'わるぢえ',
  'ずじょう',
  'むとどけ',
  'しおづけ',
  'ほんぞん',
  'はくらい',
  'そうけん',
  'けいてき',
  'ぬきうち',
  'ていがく',
  'ぜんよう',
  'ぎしょう',
  'てきたい',
  'がくばつ',
  'でなおす',
  'あくせい',
  'ふるまい',
  'たしょく',
  'こうせつ',
  'ほうてき',
  'とめがね',
  'ぎょみん',
  'かみわざ',
  'ぼういん',
  'まえがき',
  'でまわる',
  'いつだつ',
  'へんどう',
  'しらさぎ',
  'ぜんべい',
  'ぼうどく',
  'えんかん',
  'ふくしき',
  'ほんしゃ',
  'いんとく',
  'かたむき',
  'かくざい',
  'げんあつ',
  'ついそう',
  'とりくち',
  'こむぎこ',
  'しょたい',
  'じょうよ',
  'とりもつ',
  'きじょう',
  'らんぞう',
  'さいみつ',
  'ききがき',
  'たけうま',
  'こつにく',
  'やまわけ',
  'もとじめ',
  'ゆうしゃ',
  'そうきん',
  'とくしん',
  'いぎょう',
  'ごうだつ',
  'おしょく',
  'なかよく',
  'せんよう',
  'せいほん',
  'せいきょ',
  'きょくど',
  'はきゅう',
  'ぞうえい',
  'しちょく',
  'けつぞく',
  'おいたち',
  'くじゅう',
  'しきかく',
  'がいさい',
  'ぶってき',
  'ゆうぐれ',
  'たいてき',
  'れきせん',
  'りんかい',
  'とっかん',
  'とくさつ',
  'すいたい',
  'みちびき',
  'すうせん',
  'じんどう',
  'せいしゃ',
  'さっとう',
  'ろうほう',
  'よわまり',
  'しむける',
  'すいぎん',
  'ふくげん',
  'あやつり',
  'くろいろ',
  'ようざい',
  'へいばん',
  'ていない',
  'がんばる',
  'せきえい',
  'もちあじ',
  'すなはま',
  'じんめん',
  'めいにち',
  'なっとく',
  'ひきぬき',
  'にっぽう',
  'すいめん',
  'つちかう',
  'かけじく',
  'まどぐち',
  'にしょく',
  'みぎよつ',
  'しゃせん',
  'りきそう',
  'ひとまえ',
  'おんぞん',
  'ほそめる',
  'しゅうと',
  'そうすい',
  'めいそう',
  'いささか',
  'うわむき',
  'あくどう',
  'でんしん',
  'そんしつ',
  'あてこむ',
  'いたがみ',
  'やくいん',
  'じゃのめ',
  'しゃがい',
  'もくほん',
  'おおもの',
  'かきょう',
  'いたのま',
  'せんいん',
  'はいたい',
  'らくてん',
  'みとれる',
  'さんまん',
  'めのまえ',
  'はんかい',
  'けっきん',
  'ゆうへい',
  'まきがい',
  'かじゅう',
  'ふくちじ',
  'みすかす',
  'ぶんめん',
  'かんてい',
  'ひきがね',
  'うらもん',
  'こうあん',
  'よめいり',
  'ひよりみ',
  'かたてま',
  'かんぼう',
  'こんとん',
  'たなあげ',
  'じんちく',
  'べっかん',
  'りゅうし',
  'きばらし',
  'はなみち',
  'てまねき',
  'せんごく',
  'つうれい',
  'さんかん',
  'ひきかえ',
  'かいだい',
  'ひいらぎ',
  'へいねん',
  'ていとく',
  'バイブル',
  'きりうり',
  'はやあし',
  'いならぶ',
  'きまって',
  'はなびえ',
  'せきぐん',
  'みみもと',
  'いさかい',
  'しつよう',
  'はいせき',
  'まどぎわ',
  'はいとう',
  'せんなり',
  'ゆびおり',
  'せいとん',
  'ぶつでん',
  'れんけい',
  'ねんぽう',
  'みじたく',
  'ぐんかん',
  'ぜいげん',
  'えしゃく',
  'はくしん',
  'ほうやく',
  'ていすう',
  'かんげつ',
  'ざいせき',
  'いきょく',
  'さんかい',
  'こんだて',
  'べっしつ',
  'みささぎ',
  'だいじゃ',
  'ほんばん',
  'どうてん',
  'てだすけ',
  'げきたい',
  'せんれき',
  'にがおえ',
  'しゃじく',
  'だきあう',
  'まつじつ',
  'しゃない',
  'むせいふ',
  'しちょう',
  'びだんし',
  'すいがい',
  'たましい',
  'ほりだす',
  'れいせつ',
  'あいさい',
  'さんしゅ',
  'ほちょう',
  'ぶんかん',
  'せいなん',
  'どうはん',
  'はちょう',
  'くちきき',
  'かさねぎ',
  'はんもく',
  'ばいりん',
  'れんどう',
  'とくだん',
  'れんかん',
  'ひょうど',
  'わりばし',
  'はちまん',
  'みずぎわ',
  'きょうさ',
  'まくあい',
  'なかでも',
  'りゅうは',
  'かくせい',
  'くにもと',
  'たいぐん',
  'おおかみ',
  'さんぼん',
  'はいでん',
  'くちばし',
  'ぜんそく',
  'すどおり',
  'ほんじつ',
  'ぶんいん',
  'ベランダ',
  'せつえい',
  'ていおん',
  'らいめい',
  'かしほん',
  'きんるい',
  'ふるって',
  'だいもく',
  'しょくひ',
  'いけがき',
  'しんじん',
  'ちかみち',
  'ういざん',
  'ぼくしゃ',
  'はんにち',
  'えいさい',
  'このんで',
  'ひこうし',
  'せんぱつ',
  'のりこす',
  'とうれい',
  'しまぐに',
  'ちんしゃ',
  'しゅひん',
  'むさぼる',
  'ちゅうひ',
  'ちぐはぐ',
  'ようけい',
  'げいいき',
  'うちどめ',
  'ないほう',
  'ひんぱつ',
  'ほったん',
  'しがいち',
  'かんみん',
  'れいぶん',
  'じょばん',
  'ぬけあな',
  'すじがき',
  'よみかき',
  'かえうた',
  'もとより',
  'けっかい',
  'だっすい',
  'ないけい',
  'ほうれい',
  'けつぜい',
  'みくびる',
  'さんせん',
  'にんじん',
  'ぐんぞう',
  'ぶんかつ',
  'ほんぽう',
  'いりごみ',
  'なりゆき',
  'つきだす',
  'せしゅう',
  'ぼうびき',
  'すけっと',
  'しんたく',
  'ざんにん',
  'くろぬり',
  'ふんばる',
  'ぶんだん',
  'とくそう',
  'ようがし',
  'ねとまり',
  'ごじゅう',
  'ばくまつ',
  'ふゆどり',
  'ふうぼう',
  'ぞうりん',
  'ひとりご',
  'へんしゃ',
  'へんさん',
  'ねんじる',
  'げきつう',
  'げんじん',
  'げんがく',
  'みきわめ',
  'ざつがく',
  'はこぶね',
  'どくぜつ',
  'らくじつ',
  'きんねん',
  'もりこむ',
  'げんぱん',
  'よわごし',
  'ゆちゃく',
  'ぬいばり',
  'ふゆやま',
  'ジャパン',
  'てっきん',
  'へいえい',
  'あとかた',
  'ものしり',
  'ねんがく',
  'らくさつ',
  'かりょう',
  'きんかん',
  'ひとやま',
  'カントン',
  'むやみに',
  'きょうき',
  'たつじん',
  'べんがく',
  'くんれい',
  'ぜんこう',
  'きびょう',
  'あくへい',
  'ちかって',
  'おやどり',
  'きんしつ',
  'ぎょうし',
  'したうち',
  'のうがき',
  'ねんさん',
  'らんばつ',
  'おちいる',
  'たんしん',
  'なれっこ',
  'しょにち',
  'てのうち',
  'いしばし',
  'さいどく',
  'ひんもく',
  'しおあじ',
  'だいごみ',
  'とりまき',
  'ばっすい',
  'おんねつ',
  'ぜんやく',
  'けんそう',
  'うちだす',
  'もくそく',
  'わかぞう',
  'そうさい',
  'さいげん',
  'いざかや',
  'らんかん',
  'かいとる',
  'つけだし',
  'きゅうき',
  'ちんぼつ',
  'どうせき',
  'へいがく',
  'もちいえ',
  'さんぱい',
  'さかしま',
  'わずらい',
  'うけおう',
  'かくやく',
  'あいしょ',
  'ていめい',
  'ていあつ',
  'にょじつ',
  'おおしお',
  'ゆうげき',
  'だいとう',
  'こていひ',
  'ほりゅう',
  'あわれむ',
  'しきょう',
  'のうみつ',
  'ほどこし',
  'ていやく',
  'はいしん',
  'ぜんちょ',
  'ぼうこく',
  'ぎょうき',
  'あいべや',
  'ねんらい',
  'ないそう',
  'はるめく',
  'うつぶせ',
  'よりょく',
  'きんよく',
  'まんかい',
  'あしおと',
  'つうほう',
  'しゅつば',
  'アリバイ',
  'ぞうせつ',
  'ふうじて',
  'うみがめ',
  'そうこん',
  'だっとう',
  'もくにん',
  'よみがえ',
  'はながた',
  'げんわく',
  'らんけい',
  'てっせい',
  'がいさん',
  'かるいし',
  'たんちき',
  'やきとり',
  'とびでる',
  'せっすい',
  'きょがく',
  'らんどく',
  'いきのね',
  'なんべん',
  'ぶんみん',
  'はりあい',
  'せきとり',
  'レシート',
  'こくでん',
  'おおだい',
  'あいうち',
  'なんざん',
  'ほうかつ',
  'どけんや',
  'ねんかい',
  'りんせつ',
  'いちれつ',
  'らんしゃ',
  'こくたい',
  'きんちょ',
  'むろまち',
  'ししょう',
  'へんのう',
  'とくだい',
  'ねんりつ',
  'ぼうさつ',
  'くすぐる',
  'ないせん',
  'たいきょ',
  'ないこう',
  'そくばい',
  'げんばつ',
  'みかえり',
  'せいじか',
  'あらいば',
  'ひきあげ',
  'しゅうか',
  'わりふる',
  'りんかん',
  'てんもん',
  'ねすごす',
  'じりゅう',
  'みぎがわ',
  'ぎじろく',
  'のばなし',
  'めいげつ',
  'ていほん',
  'おしょう',
  'すいろん',
  'りきとう',
  'わりだす',
  'めいくん',
  'いみょう',
  'さいらい',
  'えんたく',
  'こがわせ',
  'いしょく',
  'いっしつ',
  'べつむね',
  'よこみち',
  'たいじゅ',
  'もちにげ',
  'しきもの',
  'しゃだん',
  'にじゅう',
  'えいそう',
  'いちろう',
  'すていし',
  'いえもと',
  'ゆかした',
  'そくへき',
  'はるかぜ',
  'せんどう',
  'くうしつ',
  'たてうり',
  'でんきろ',
  'ぎむづけ',
  'ちゃくし',
  'とむらう',
  'ずいいち',
  'えんしん',
  'とうさい',
  'はからい',
  'はみだす',
  'へんそう',
  'あんやく',
  'まいきょ',
  'クッキー',
  'しょうよ',
  'おんとう',
  'つつしみ',
  'たかだか',
  'けつべつ',
  'せんねん',
  'れっせき',
  'いちだい',
  'いどころ',
  'じつぶつ',
  'げんすい',
  'ごうれい',
  'げんぼく',
  'ラーメン',
  'いんえい',
  'おんこう',
  'みちづれ',
  'かいへい',
  'げんえい',
  'てらこや',
  'ぼんじん',
  'ここじん',
  'しょうさ',
  'よくぼう',
  'かみゆい',
  'ひきしめ',
  'なんよう',
  'かおだち',
  'そうせき',
  'れいぜん',
  'ほうだい',
  'のりつけ',
  'みょうみ',
  'はつねつ',
  'だいきち',
  'ほうすい',
  'ぜんぱい',
  'こうもん',
  'あいいく',
  'ひっこみ',
  'みっこう',
  'しごせん',
  'きんじつ',
  'せつごう',
  'めかくし',
  'かっさい',
  'だしなげ',
  'こくがい',
  'みしらぬ',
  'ふくくう',
  'おしろい',
  'へいぞん',
  'まりょく',
  'ふきかえ',
  'ほそみち',
  'はんがく',
  'もちさる',
  'りかがく',
  'いろわけ',
  'へいそく',
  'はんそく',
  'たきこみ',
  'どくぜん',
  'へいけい',
  'ろうれい',
  'すうこう',
  'おうこう',
  'おしきせ',
  'じちけん',
  'はちほん',
  'ふうりん',
  'にんたい',
  'げんぽん',
  'たちあい',
  'どうぞう',
  'かふくぶ',
  'みのうえ',
  'さいする',
  'しきぼう',
  'はんにゃ',
  'ほんろう',
  'べつじん',
  'かいこん',
  'そよかぜ',
  'たいぐう',
  'はくじゅ',
  'ざいほう',
  'やまびと',
  'きはつゆ',
  'べにばな',
  'まんせい',
  'じゅくち',
  'からくさ',
  'いちどく',
  'ないじょ',
  'びりょく',
  'そびえる',
  'きんみつ',
  'がくいん',
  'ぎじょう',
  'アピール',
  'いどほり',
  'ろっかく',
  'ぼにゅう',
  'おんかい',
  'きょしん',
  'なんこつ',
  'いちやく',
  'しゃくど',
  'れきにん',
  'しききん',
  'たんてい',
  'いってき',
  'ずいいん',
  'こわばる',
  'りゅうち',
  'ようだい',
  'ぜんざん',
  'ようばい',
  'あさがお',
  'いちぞく',
  'ちょうみ',
  'うたがい',
  'ぞうはん',
  'せんぎょ',
  'じょうい',
  'なげわざ',
  'りつぞう',
  'うらない',
  'けんらん',
  'べいさん',
  'かみがた',
  'いちぼく',
  'しょえん',
  'こわだか',
  'ぞうがく',
  'でんれい',
  'どうじる',
  'うちでし',
  'みならう',
  'たちいり',
  'きんせつ',
  'がんぺき',
  'どくぶつ',
  'とうわく',
  'ドタバタ',
  'けんりつ',
  'おどりば',
  'いちげい',
  'しゅぞく',
  'いきうめ',
  'ゆにゅう',
  'のうぜい',
  'みつぞう',
  'ぎゅうほ',
  'わりかん',
  'つうはん',
  'まえあし',
  'よそおう',
  'かんぶん',
  'ひっさつ',
  'てこずる',
  'やきうち',
  'さんいん',
  'はんぼう',
  'ひととき',
  'さかもり',
  'らんがく',
  'やまでら',
  'だっかい',
  'うらかた',
  'はやまる',
  'ぜんめん',
  'りょっか',
  'だっしゅ',
  'しろもの',
  'ほどける',
  'べんぜつ',
  'がんきん',
  'ぜんはん',
  'へんてん',
  'かげぐち',
  'ようろう',
  'よくしつ',
  'のびやか',
  'ざんてい',
  'はびこる',
  'ほっぽう',
  'れいばい',
  'じょえん',
  'ごうすう',
  'どうざい',
  'うたごえ',
  'とびいり',
  'ゆうべん',
  'おくまん',
  'はんげん',
  'あさぬの',
  'おととし',
  'たてつく',
  'ぜんれい',
  'はっきん',
  'そうしん',
  'れんけつ',
  'たんもの',
  'さんぞく',
  'かんばつ',
  'ゆうする',
  'じゅりん',
  'すんぜん',
  'りんじん',
  'せんおう',
  'いちめい',
  'きがえる',
  'かっせん',
  'らいこう',
  'せんいき',
  'だんじょ',
  'とうほう',
  'げんぶつ',
  'いんがし',
  'せいどく',
  'ひょうひ',
  'まじきり',
  'あとおし',
  'かしゅう',
  'べいさく',
  'ふごうり',
  'おくのて',
  'こうねん',
  'はいてん',
  'しめだす',
  'こんすい',
  'こくてん',
  'ほんしん',
  'ぞうふく',
  'けちえん',
  'らくばん',
  'はいおく',
  'じっせん',
  'そうごん',
  'びいしき',
  'ろじょう',
  'せんべい',
  'はいごう',
  'ほにゅう',
  'ゆうどく',
  'おかしな',
  'きこなす',
  'かざしも',
  'うおがし',
  'さいろく',
  'せんぐう',
  'ぼうがい',
  'ものごし',
  'にしぐち',
  'ぞうすい',
  'わるぐち',
  'いちれい',
  'げきさく',
  'にくしつ',
  'とうどり',
  'ふところ',
  'ほりばた',
  'あおだけ',
  'かたしき',
  'よそおい',
  'たちばな',
  'ピンポン',
  'いいぶん',
  'けんさく',
  'あさいち',
  'おうりつ',
  'ひきつぎ',
  'ぞっかい',
  'まぎらす',
  'えんでん',
  'どくえん',
  'やまおく',
  'ほうふつ',
  'ききゃく',
  'あめふり',
  'へんしつ',
  'おんいき',
  'ざいきん',
  'してかぶ',
  'ききいる',
  'うすいた',
  'ゆびきり',
  'ようつう',
  'ごうがい',
  'こうまん',
  'ばつぐん',
  'やじゅう',
  'じゅたく',
  'うわやく',
  'かたすみ',
  'みはらす',
  'ぞうはい',
  'ゆかうえ',
  'きょじん',
  'じきゅう',
  'くいにげ',
  'もうしご',
  'えんよう',
  'ぶんけい',
  'たいぜん',
  'はんすう',
  'へいてい',
  'こっかん',
  'しんがん',
  'よこがお',
  'ぜんでら',
  'てんまく',
  'みまわる',
  'とうやく',
  'はやびけ',
  'ぐったり',
  'しっきん',
  'さいぶん',
  'わけあう',
  'みちばた',
  'たつまき',
  'こくぐん',
  'しんぼく',
  'ていかん',
  'おりがみ',
  'だいのう',
  'はくしょ',
  'うちあう',
  'ホンコン',
  'おうこく',
  'わけまえ',
  'せいつう',
  'へんよう',
  'まるだし',
  'しんかぶ',
  'どうじつ',
  'じょろう',
  'じゃどう',
  'たちいる',
  'しゃくち',
  'ふかしぎ',
  'こてなげ',
  'だったい',
  'しゅんき',
  'はごたえ',
  'れいげん',
  'てみやげ',
  'むひはん',
  'せっかち',
  'しっけい',
  'とりきめ',
  'はないき',
  'ほうらく',
  'いちるい',
  'ゆきかう',
  'だしあう',
  'しゅせん',
  'ひるまえ',
  'ついげき',
  'とくせつ',
  'つめしょ',
  'そんゆう',
  'ふるきず',
  'きみがよ',
  'えどっこ',
  'こくるい',
  'じむてき',
  'ざいだん',
  'てつじん',
  'たんにん',
  'つけびと',
  'いくえい',
  'につめる',
  'だんがん',
  'ぼうじゅ',
  'やしない',
  'アイドル',
  'はんりょ',
  'せおよぎ',
  'あぶらみ',
  'ぎんせい',
  'どうりつ',
  'たいわん',
  'ばんぜん',
  'かいわい',
  'くったく',
  'ほうおう',
  'ちゃくち',
  'こんやく',
  'おりから',
  'かけだし',
  'しゃくや',
  'りくうん',
  'さんそう',
  'せつぼう',
  'きりさめ',
  'じじゅう',
  'こどうぐ',
  'こんめい',
  'ふりこみ',
  'スーパー',
  'しのはい',
  'てんじゅ',
  'ぶらんこ',
  'みはなす',
  'げきどう',
  'またたく',
  'こうがく',
  'へんすう',
  'たいまつ',
  'えんさん',
  'あんみん',
  'ざいばつ',
  'うちとる',
  'さいみん',
  'ざんしん',
  'とくせん',
  'つきそう',
  'どうこん',
  'だしいれ',
  'こうほう',
  'たんぱつ',
  'しんがた',
  'うめたて',
  'へんさち',
  'てんさく',
  'がくゆう',
  'てかげん',
  'くういき',
  'ゆいのう',
  'しんがい',
  'えんめい',
  'そうだい',
  'なばかり',
  'つきづき',
  'どうぎご',
  'せきねん',
  'ぐんせい',
  'どくぼう',
  'さしょう',
  'しんぺい',
  'ちんたい',
  'たてよこ',
  'ほうとう',
  'あいしゃ',
  'としした',
  'ぐんじん',
  'こんいん',
  'ふてぎわ',
  'すいぼつ',
  'あさばん',
  'はいじん',
  'てんけん',
  'きりあげ',
  'たようか',
  'きょしつ',
  'さじょう',
  'やっこう',
  'はんしん',
  'かいそく',
  'あんてん',
  'すいしん',
  'みがまえ',
  'はっぷん',
  'おんばん',
  'はんしゅ',
  'こうずる',
  'かけだす',
  'ねつげん',
  'しもふり',
  'せっぱん',
  'さんぐん',
  'ちょしょ',
  'がくめい',
  'きりだす',
  'しんさく',
  'きんせい',
  'しっさく',
  'たきこむ',
  'しょねん',
  'けっする',
  'ひきつる',
  'えんてん',
  'ぼんよう',
  'せんかん',
  'つゆいり',
  'ねんしょ',
  'おしいり',
  'とっしん',
  'はっする',
  'せんぷう',
  'ふくらみ',
  'こんぼう',
  'げんみつ',
  'せんがい',
  'シンボル',
  'かいこむ',
  'やくめい',
  'ふるほん',
  'たかだい',
  'ぐうはつ',
  'にくづけ',
  'からぶり',
  'しんぐん',
  'しょうふ',
  'スムーズ',
  'せんにん',
  'りょくち',
  'あんそく',
  'てっとう',
  'とうじん',
  'ぜんぐん',
  'あじつけ',
  'あなぐま',
  'ちんてい',
  'しつれい',
  'すみずみ',
  'せっとう',
  'しょあく',
  'けいひん',
  'ふくしん',
  'ぶんさつ',
  'まんだら',
  'なかまく',
  'りんせん',
  'きずあと',
  'ぼうめい',
  'うすかわ',
  'ねがいで',
  'こんまけ',
  'ほんてん',
  'せとぎわ',
  'けんちじ',
  'さきだつ',
  'すいもの',
  'しとやか',
  'きりふき',
  'げんぜん',
  'ぼくめつ',
  'うもれる',
  'なっとう',
  'こじいん',
  'どうぞく',
  'しょだな',
  'いちゅう',
  'せってん',
  'ぜいほう',
  'せきさい',
  'ねさがり',
  'せいざん',
  'むいしき',
  'きゅうひ',
  'しゅっし',
  'りんしつ',
  'そうぐん',
  'ゆいごん',
  'がしょう',
  'ばじゅつ',
  'エアコン',
  'だんいん',
  'かくしつ',
  'さんてい',
  'しゅくじ',
  'にほんご',
  'ひきさく',
  'しゃさつ',
  'がくせき',
  'しりょく',
  'りくかい',
  'ろくがつ',
  'わぎゅう',
  'しんぱく',
  'しゅじん',
  'まえぶれ',
  'てっそく',
  'こうへん',
  'じんとう',
  'ろうにん',
  'なべもの',
  'しゃざい',
  'ふうどう',
  'せんぞく',
  'かいせき',
  'てわたし',
  'のびりつ',
  'ほしぞら',
  'ほうでん',
  'ほんそう',
  'ぜんれき',
  'みっせい',
  'たしかめ',
  'とうさく',
  'ざいたく',
  'てんそう',
  'こくてつ',
  'よあそび',
  'がくない',
  'がじょう',
  'くみこみ',
  'ろんせん',
  'よびこみ',
  'ねがえり',
  'がいゆう',
  'ほくたん',
  'もちよる',
  'こんせん',
  'かっこく',
  'みまわす',
  'ないえん',
  'ざんとう',
  'せんぎり',
  'ぶんたん',
  'はっぽう',
  'さんべつ',
  'がいかく',
  'さくらん',
  'たびだち',
  'けいがく',
  'みんぺい',
  'ふぎかい',
  'にじてき',
  'よりきり',
  'だいあん',
  'なんきん',
  'かあさん',
  'エッセイ',
  'なきあと',
  'はんよう',
  'しなかず',
  'おくそく',
  'そえもの',
  'とびだし',
  'ていこく',
  'まいぼつ',
  'みぎうで',
  'かきだす',
  'かわぐつ',
  'りきがく',
  'ぎょっと',
  'なんかん',
  'しゃほん',
  'えっとう',
  'しゅじい',
  'きりこむ',
  'りまわり',
  'つめよる',
  'かんしき',
  'たちぐい',
  'のうかい',
  'さしかえ',
  'めくばり',
  'くつろぐ',
  'ほんぞう',
  'はやめる',
  'さいだん',
  'じひびき',
  'しんぽう',
  'おおあれ',
  'へいいん',
  'れきねん',
  'おまもり',
  'やくよう',
  'ざんぞん',
  'とくやく',
  'ことわり',
  'あしぶみ',
  'だりょく',
  'せいでん',
  'ぞうえん',
  'けっぺき',
  'つうさん',
  'うちぼり',
  'ぞうさん',
  'りんどう',
  'こむすび',
  'りんせき',
  'まるみえ',
  'ふくとう',
  'みずいろ',
  'まきあみ',
  'げんぽう',
  'なんとう',
  'すうじく',
  'のうせい',
  'すいごう',
  'かたいれ',
  'ひしょう',
  'でんごん',
  'めいせき',
  'くちょう',
  'しょうそ',
  'くっさく',
  'ぜんせい',
  'だんこう',
  'ぼつらく',
  'げんめい',
  'ねんすう',
  'べついん',
  'ぎょえん',
  'くんよみ',
  'きんらい',
  'よわむし',
  'ぜんもう',
  'げんさい',
  'ぞくせい',
  'ようこう',
  'しゃたい',
  'たくわえ',
  'もうつい',
  'らんりつ',
  'でんがく',
  'とってい',
  'みとおす',
  'はだあい',
  'そうばん',
  'たいけつ',
  'ふていき',
  'もんせき',
  'でんどう',
  'ばいえん',
  'もうしょ',
  'えんじゃ',
  'てんとり',
  'びょうし',
  'るいせき',
  'やきょく',
  'あてさき',
  'ようかん',
  'つかのま',
  'せいあつ',
  'おおあざ',
  'しみこむ',
  'しゅぶん',
  'しゅっか',
  'ロボット',
  'あせみず',
  'ほうむる',
  'ゆうはつ',
  'くらもと',
  'くさばな',
  'あんたい',
  'かんてつ',
  'ほくげん',
  'けしいん',
  'しゅらん',
  'えりまき',
  'ほうふく',
  'へいげん',
  'らくせき',
  'かんあん',
  'がっそう',
  'よんせん',
  'べつもの',
  'としおい',
  'ぐしょう',
  'よんほん',
  'おふくろ',
  'とりさげ',
  'みんじゅ',
  'ちゃしつ',
  'こうてつ',
  'もうまく',
  'せいてん',
  'ばんさん',
  'ごさんけ',
  'しゃさい',
  'ぎんばん',
  'いしころ',
  'ちひょう',
  'だいめい',
  'げっかん',
  'じつげつ',
  'はたもと',
  'えんざい',
  'しっぷう',
  'せんぱん',
  'のうきぐ',
  'つうふう',
  'ごうてい',
  'ねぶそく',
  'せんべつ',
  'けつえん',
  'ちょうそ',
  'とうぞく',
  'とりくみ',
  'そとぼり',
  'やすもの',
  'おいだす',
  'とくてん',
  'はいべん',
  'ひんせい',
  'ようけん',
  'とびさる',
  'せいりぶ',
  'つうれつ',
  'つなひき',
  'こくだい',
  'せわもの',
  'ほうとく',
  'そうがい',
  'けいあい',
  'くちだし',
  'ぼうこう',
  'たきぐち',
  'とくそく',
  'みじかめ',
  'ふりきる',
  'めいかん',
  'きたやま',
  'ふなのり',
  'ひだりて',
  'やまみち',
  'えんたい',
  'てびかえ',
  'つうこく',
  'よやとう',
  'じゅんろ',
  'せんしん',
  'はやざき',
  'どうせん',
  'てざわり',
  'けしさる',
  'まっさつ',
  'ねんさい',
  'しちがつ',
  'ながねん',
  'ゆうふく',
  'はなぞの',
  'いつごろ',
  'きゅうゆ',
  'のっとり',
  'てっぱん',
  'ぐんこく',
  'いなさく',
  'せいこん',
  'しんだい',
  'にひゃく',
  'かぎょう',
  'ひにくる',
  'かりこむ',
  'せんけつ',
  'かいする',
  'ぜんかん',
  'きながし',
  'たそがれ',
  'そしゃく',
  'たんさん',
  'ほうかん',
  'むきゅう',
  'ほんがん',
  'チェーン',
  'てんぼう',
  'たかぶる',
  'きょしき',
  'こうわん',
  'のうめん',
  'がくめん',
  'あいつぐ',
  'がくだん',
  'げきじん',
  'たかまり',
  'ほうさく',
  'ほうにん',
  'ちじょう',
  'しんぶつ',
  'だんぺん',
  'ないめん',
  'けっぱく',
  'いっつう',
  'たちのき',
  'いただき',
  'まんえつ',
  'そんみん',
  'おおゆき',
  'のうきん',
  'すいしつ',
  'うらぎり',
  'にしかぜ',
  'むりょく',
  'ぼひょう',
  'たきだし',
  'けいだい',
  'ぼんさい',
  'ねんとう',
  'にくしん',
  'とくさく',
  'がくぶち',
  'じつづき',
  'ぼうげん',
  'おうせん',
  'そうほう',
  'やまづみ',
  'やきもの',
  'いなずま',
  'おんじん',
  'おどかし',
  'しゅわん',
  'しんぷく',
  'かんじゅ',
  'へいえき',
  'てんめい',
  'ごうりか',
  'からまる',
  'こわいろ',
  'ぶさほう',
  'ふうしょ',
  'しんたい',
  'しんのう',
  'こしだか',
  'しゃけん',
  'きりばり',
  'じょぶん',
  'かいひん',
  'おちあう',
  'そのもの',
  'がぎょう',
  'たいとく',
  'うかがい',
  'おうしん',
  'えいぜん',
  'らくせん',
  'おしきる',
  'ふっとぶ',
  'えんせい',
  'えきまえ',
  'さいるい',
  'やきゅう',
  'えきいん',
  'ふさくい',
  'ちりょく',
  'あみだな',
  'さんよう',
  'れんせん',
  'にこやか',
  'れっしん',
  'たてかえ',
  'きりつめ',
  'とまどい',
  'きりだし',
  'けっかく',
  'しゅぞう',
  'じゅもん',
  'きょうこ',
  'ふじんか',
  'くしょう',
  'たていと',
  'はきもの',
  'てんだい',
  'そうする',
  'だいふく',
  'ほんもう',
  'きょたい',
  'さいにん',
  'せんれん',
  'きょくう',
  'てっぺい',
  'ぶつだん',
  'かなでる',
  'しまじま',
  'しんさい',
  'かわりめ',
  'へんれき',
  'せんそく',
  'ちんこん',
  'かんしゅ',
  'みぎきき',
  'べんさい',
  'おんくん',
  'あらうみ',
  'かちゅう',
  'えんきん',
  'むきあう',
  'ならびに',
  'かおむけ',
  'うらはら',
  'うつむく',
  'こうえい',
  'じゅんか',
  'にしがわ',
  'じってい',
  'がいじゅ',
  'はりこみ',
  'そうざい',
  'とっぷう',
  'きたより',
  'めんそう',
  'げいにん',
  'ぼうきょ',
  'とけあう',
  'びょうく',
  'しゅつじ',
  'せいぶん',
  'ひょうき',
  'こくすい',
  'れいすい',
  'ばってき',
  'ようひん',
  'はんらく',
  'くみこむ',
  'しつじつ',
  'ほっする',
  'やまかじ',
  'だきこむ',
  'のぼせる',
  'きこうし',
  'つれさる',
  'いっせき',
  'ようせん',
  'ぶんつう',
  'けんにん',
  'こくぶん',
  'たいへい',
  'しりあう',
  'げいしゃ',
  'みおとし',
  'だつぜい',
  'そうだつ',
  'にしきえ',
  'へいおん',
  'ゆめみる',
  'せつぶん',
  'まがたま',
  'おしあい',
  'たちあう',
  'たのしげ',
  'そうるい',
  'じいしき',
  'ごくどう',
  'あさがた',
  'さんとう',
  'うるおす',
  'そうきょ',
  'じゅせい',
  'とうめい',
  'やくがく',
  'へんぼう',
  'かくだん',
  'せわにん',
  'そっけつ',
  'でしいり',
  'ねんまく',
  'いっこう',
  'だいどく',
  'はながみ',
  'にのつぎ',
  'りょうけ',
  'みなさま',
  'ごっかん',
  'かどまつ',
  'かしょう',
  'そくほう',
  'はつこい',
  'あかまつ',
  'かいいれ',
  'かわぎし',
  'てったい',
  'げっこう',
  'ぶあつい',
  'おいわけ',
  'いみあい',
  'えいめい',
  'らいさん',
  'きんさく',
  'むなもと',
  'せいかい',
  'かいぶつ',
  'きゅうむ',
  'ふんさい',
  'へいりつ',
  'いちにん',
  'おきざり',
  'しょぞん',
  'はなさき',
  'ずいそう',
  'にゅうし',
  'みみより',
  'ろうねん',
  'きょげん',
  'じつえき',
  'こんせい',
  'さんけん',
  'はなうた',
  'すぎさる',
  'うちまく',
  'おおあな',
  'きょくち',
  'がようし',
  'どうもく',
  'しってん',
  'うでぐみ',
  'がいよう',
  'せきぶつ',
  'れいさい',
  'えんだか',
  'ちんじゅ',
  'かいふう',
  'もてなし',
  'ふくせん',
  'じゅうか',
  'らいひん',
  'らんどり',
  'どのへん',
  'どうこく',
  'らんとう',
  'じつまい',
  'せんしつ',
  'へいてん',
  'けんたい',
  'げきとつ',
  'ばんきん',
  'いちねん',
  'きみどり',
  'むっつり',
  'りんしょ',
  'よこいと',
  'リモコン',
  'ぼこくご',
  'しゅよく',
  'すなやま',
  'じょたい',
  'へいれつ',
  'てんとう',
  'みがって',
  'とうじき',
  'つみだし',
  'ほうぶん',
  'しょくし',
  'いちょう',
  'どうさつ',
  'たんてき',
  'かねあい',
  'じゅなん',
  'こうぐう',
  'しらかば',
  'ぶつのう',
  'きりたつ',
  'どうたく',
  'おきあい',
  'こうはん',
  'じんぐう',
  'せんぼつ',
  'はいひん',
  'だんどり',
  'さんぼう',
  'かいぬし',
  'はんめん',
  'てきはつ',
  'はしゃぐ',
  'たちぎえ',
  'ぎょろう',
  'いってん',
  'りんごく',
  'したづみ',
  'じちょう',
  'えんぶん',
  'あせだく',
  'にちぼつ',
  'えんざん',
  'へんげん',
  'おぎない',
  'むいそん',
  'ぶつもん',
  'ねそべる',
  'ひあそび',
  'しょいん',
  'きかいか',
  'なにごと',
  'ぜんさい',
  'こめぐら',
  'みずたま',
  'せんけい',
  'かいぞえ',
  'こくしょ',
  'うすらぐ',
  'とりたて',
  'そうがく',
  'かいぜん',
  'しきいし',
  'かんぶつ',
  'ろんがい',
  'せっそく',
  'もうそう',
  'きりもり',
  'じゅばく',
  'あしどり',
  'もくぞう',
  'かせいふ',
  'ゆくすえ',
  'いでんし',
  'すみやき',
  'のうがく',
  'のらいぬ',
  'はっこつ',
  'しんぷう',
  'もくとう',
  'せんぜん',
  'ようらん',
  'ちくいち',
  'ひでんか',
  'さんびか',
  'むさべつ',
  'カタログ',
  'めいはく',
  'じんしん',
  'なんぷう',
  'なきだす',
  'げんえき',
  'さくてい',
  'てきしつ',
  'せんしゃ',
  'ないがい',
  'うるおい',
  'げいふう',
  'しんきょ',
  'かおいろ',
  'てばなし',
  'れんぱつ',
  'しおやき',
  'きりくち',
  'うきたつ',
  'おりなす',
  'そっせん',
  'ちゃかい',
  'チケット',
  'よこばい',
  'ふくすけ',
  'さみだれ',
  'しょせん',
  'まんしん',
  'しんろう',
  'すうじつ',
  'よこづな',
  'ぶしどう',
  'だんこん',
  'そこねる',
  'がんてい',
  'ぐんこう',
  'にわさき',
  'ごうほう',
  'ぐんばい',
  'ものずき',
  'ちゅうや',
  'ぬけみち',
  'きめこむ',
  'れいかい',
  'せんがん',
  'たいこう',
  'そんぼう',
  'どちゅう',
  'こうざい',
  'ぎょにく',
  'ほんしょ',
  'にげこむ',
  'いっかん',
  'たりょう',
  'やまざと',
  'いちまつ',
  'はんせん',
  'いんない',
  'じゅたい',
  'ゆうだん',
  'ぼつねん',
  'しんさん',
  'ぼんのう',
  'ふっこく',
  'しょうね',
  'もちぬし',
  'くさかり',
  'たべすぎ',
  'すいせい',
  'きんかい',
  'よみかた',
  'とうせき',
  'かぶけん',
  'ばいどく',
  'みせかけ',
  'ないらん',
  'げんごう',
  'いわやま',
  'さくとう',
  'じんこつ',
  'きょえい',
  'したうけ',
  'きれあじ',
  'ほんざん',
  'ふつごう',
  'しだいに',
  'せいおう',
  'おおべや',
  'かいきん',
  'てなおし',
  'ほくとう',
  'おんどく',
  'さんもん',
  'おおぜき',
  'おうなつ',
  'すみこむ',
  'かざあな',
  'れいねん',
  'じいさん',
  'ふんぱつ',
  'なだめる',
  'しゃくし',
  'かんつう',
  'こうはつ',
  'よみもの',
  'ぞうわい',
  'そくどく',
  'もちこす',
  'さむざむ',
  'ぬくもり',
  'がんばん',
  'けいはく',
  'ひきゅう',
  'はんべい',
  'ていりつ',
  'いろどり',
  'たっぴつ',
  'てんれい',
  'おくゆき',
  'てんじん',
  'けんさん',
  'ふうじる',
  'しろみず',
  'えんばん',
  'かんせき',
  'ゆきみち',
  'れいしょ',
  'いいはる',
  'じゅかい',
  'ぶんしつ',
  'かんるい',
  'おくがた',
  'とうぜん',
  'せんめい',
  'もちかぶ',
  'ふとくい',
  'しつめい',
  'こいうた',
  'きょぞう',
  'きしゅく',
  'おおいり',
  'めぐすり',
  'あたかも',
  'れいざん',
  'つみだす',
  'みずがめ',
  'かがやき',
  'どうぜん',
  'あしずり',
  'さんする',
  'むしばむ',
  'あいどく',
  'がくしき',
  'ようつい',
  'そうぐう',
  'まるぎり',
  'ごせんふ',
  'おなじく',
  'こうあつ',
  'さくばん',
  'じっそう',
  'はきょく',
  'ありしひ',
  'よこもじ',
  'くうばく',
  'にくはく',
  'れいかん',
  'だつもう',
  'きちゃく',
  'だんゆう',
  'なかにわ',
  'きゃっか',
  'よみとり',
  'のうげい',
  'しごとば',
  'あんうん',
  'みずのみ',
  'すりきず',
  'めいぼく',
  'ごうもん',
  'きんぱく',
  'たいくう',
  'インチキ',
  'かたがき',
  'めいじつ',
  'べんごし',
  'そんじる',
  'ちちのひ',
  'しっとう',
  'ていしき',
  'はっかい',
  'ぎょこう',
  'まぼろし',
  'みぶるい',
  'ばくげき',
  'ぬけでる',
  'おおきさ',
  'めいざん',
  'しゅいん',
  'ぶんりつ',
  'ひがわり',
  'けんえき',
  'ふしぜん',
  'ふばらい',
  'せんぽう',
  'じょせつ',
  'ぜっこう',
  'ざんさつ',
  'つれこむ',
  'いしだん',
  'つきさす',
  'かっしゃ',
  'ぜいりつ',
  'キャベツ',
  'ほうねつ',
  'にっすう',
  'にっしゃ',
  'けんげき',
  'さいえん',
  'あんごう',
  'わけいる',
  'ほんじん',
  'しゃうん',
  'にじげん',
  'けっさい',
  'はいぶつ',
  'きにいり',
  'やすらぎ',
  'けつじつ',
  'みやぶる',
  'じゅんし',
  'れっこく',
  'くうりく',
  'せつもん',
  'だんぱつ',
  'ふくがく',
  'ひんけつ',
  'へんそく',
  'けっそう',
  'おおむぎ',
  'ほくせい',
  'たてこむ',
  'とっくり',
  'はくじん',
  'おきがさ',
  'みのがし',
  'とくめい',
  'はざくら',
  'さけずき',
  'ぜんぼう',
  'めいぶん',
  'かんまつ',
  'あやしげ',
  'ふりわけ',
  'みかえす',
  'しゅくず',
  'なんしき',
  'やまもり',
  'ざがしら',
  'こうじん',
  'せきぜん',
  'べっきょ',
  'みんかん',
  'こうぞく',
  'けんじつ',
  'くうぜん',
  'やねうら',
  'にゅうぶ',
  'にんそう',
  'さいせん',
  'かんばい',
  'れんとう',
  'みっそう',
  'そうじゃ',
  'きゅうご',
  'したじき',
  'あいとう',
  'へんぞう',
  'とりこみ',
  'よこむき',
  'せつれつ',
  'はきだす',
  'みずいり',
  'ひとくい',
  'かんえつ',
  'へんぴん',
  'つりぼり',
  'かったつ',
  'やまぶし',
  'タンカー',
  'じょれつ',
  'よばわり',
  'たいだん',
  'ぶんれい',
  'こうれつ',
  'きりぬき',
  'せいにく',
  'げんまい',
  'かくすう',
  'へんじる',
  'せひょう',
  'けっせつ',
  'じょうば',
  'いのしし',
  'こうきん',
  'えだまめ',
  'しっせき',
  'ぼうおん',
  'ざいこう',
  'にげあし',
  'ふわたり',
  'だきゅう',
  'しょゆう',
  'かけきん',
  'ぶっけん',
  'こんざい',
  'かいしょ',
  'ろうちん',
  'べんけい',
  'そんえき',
  'ゆうえい',
  'わこうど',
  'きりすて',
  'ゆうかく',
  'ろんぽう',
  'うんよく',
  'そこうち',
  'さんざい',
  'にんぎょ',
  'いりくむ',
  'りきゅう',
  'よびだし',
  'おうふう',
  'へんけい',
  'どうおん',
  'きんだん',
  'よりつき',
  'かけおち',
  'ちまなこ',
  'せいたん',
  'ようえん',
  'しょうい',
  'しんみつ',
  'ごうかん',
  'すんげき',
  'けんぞう',
  'りゅうほ',
  'げきせん',
  'ごうけん',
  'ふりかえ',
  'そっきん',
  'くさとり',
  'るいれい',
  'キリスト',
  'こうなご',
  'うわかわ',
  'くたばる',
  'ねくずれ',
  'あまから',
  'でんそう',
  'ぜんてん',
  'くっしん',
  'せいほく',
  'うらみち',
  'げきやく',
  'ほこさき',
  'きゅうぎ',
  'ほんたて',
  'とどけで',
  'つきだし',
  'もつれる',
  'とおえん',
  'ぜんせつ',
  'こくそう',
  'なんてん',
  'ちぎれる',
  'てしごと',
  'いわはだ',
  'どりょう',
  'いちりん',
  'あきない',
  'むさくい',
  'まなでし',
  'ふかおい',
  'れんぱい',
  'すいほう',
  'けんあく',
  'そうかい',
  'やまもと',
  'ぐんらく',
  'しろいろ',
  'だっかん',
  'ざいあく',
  'ぼうじょ',
  'ふくかん',
  'あんぶん',
  'せきわけ',
  'ようしゃ',
  'しつおん',
  'くうてん',
  'じゅすい',
  'しゃてい',
  'じつぞん',
  'おんせつ',
  'くうろん',
  'まったん',
  'いきごみ',
  'まじゅつ',
  'あくやく',
  'つれだす',
  'すみこみ',
  'かんでん',
  'てんびき',
  'ちんさげ',
  'ほんあん',
  'じんてき',
  'しゅひつ',
  'たいばつ',
  'はいせつ',
  'かけすて',
  'アベック',
  'つまさき',
  'すうせい',
  'かわうお',
  'やりとり',
  'みちのり',
  'ほうのう',
  'いぶくろ',
  'いくにち',
  'かんらく',
  'ゆうずう',
  'ねつれつ',
  'てんせい',
  'たくはつ',
  'ばあたり',
  'はやわざ',
  'おんねん',
  'へいがい',
  'さいたい',
  'げんろく',
  'ひつぜつ',
  'こうろう',
  'うらづけ',
  'りばらい',
  'ばんこん',
  'かたりて',
  'くんりん',
  'ばいにん',
  'まいこむ',
  'うみだす',
  'つうたつ',
  'いきさき',
  'やけあと',
  'ひきどき',
  'いちあん',
  'そうはつ',
  'げんせい',
  'できばえ',
  'ばんせい',
  'ぶんじん',
  'めいげん',
  'さんじょ',
  'うすまる',
  'ほんらん',
  'こくほう',
  'ざわめく',
  'みょうぎ',
  'みっぷう',
  'へいしゃ',
  'ばくちく',
  'てつぶん',
  'あこがれ',
  'きょうだ',
  'くろまく',
  'さんるい',
  'うすぎり',
  'ぜんそう',
  'ときには',
  'ていまい',
  'かわじり',
  'ようさい',
  'てんよう',
  'せんだつ',
  'ぼうだち',
  'だいぶつ',
  'あんとう',
  'でんぶん',
  'しっそう',
  'わかくさ',
  'とくせい',
  'みかぎる',
  'えいびん',
  'おおがた',
  'さんしん',
  'そこいれ',
  'しゅくい',
  'べんぽう',
  'あいよう',
  'いっせん',
  'むぞうさ',
  'よこどり',
  'おうぞく',
  'いつわる',
  'すいとる',
  'どっきょ',
  'うちいり',
  'たてふだ',
  'しんちゃ',
  'かいなん',
  'つりせん',
  'みんゆう',
  'しばくさ',
  'とびかう',
  'ふくれる',
  'だつらく',
  'じつぞう',
  'かていい',
  'さつりく',
  'ひやあせ',
  'えんかく',
  'だんあつ',
  'よくばる',
  'りんかく',
  'ぶつぜん',
  'げきろん',
  'みっぺい',
  'ぎょしゃ',
  'なかじま',
  'こうけつ',
  'ぜんねん',
  'さんすい',
  'いしがき',
  'てっぱい',
  'はいかい',
  'まないた',
  'ドーナツ',
  'どくだん',
  'はいこう',
  'たいにん',
  'とうめん',
  'あそばす',
  'きぐろう',
  'しらかべ',
  'げんぱつ',
  'きんそく',
  'ろんじん',
  'ぞうせい',
  'おうねん',
  'がくえん',
  'うわのせ',
  'ざいかい',
  'いしわた',
  'ひとかげ',
  'めざわり',
  'さきもの',
  'さかなや',
  'そうりょ',
  'あんのん',
  'せいたい',
  'さかなで',
  'しんめい',
  'じんせん',
  'くきょう',
  'しじゅく',
  'コットン',
  'ていらく',
  'じょやく',
  'おおばん',
  'てきせい',
  'なみかぜ',
  'にげきる',
  'おんびん',
  'おしいる',
  'ゆうぜい',
  'おいこし',
  'ゆうりょ',
  'きりとり',
  'ねんぱい',
  'おおだな',
  'にぶらす',
  'もんよう',
  'きんぼし',
  'くちうら',
  'ないきん',
  'じょうむ',
  'ぞうえき',
  'ひましに',
  'じゆうか',
  'てちがい',
  'がいあく',
  'くっぷく',
  'らいえん',
  'とりあい',
  'おとろえ',
  'つめこむ',
  'せんたい',
  'はくしき',
  'ふしんび',
  'げんせん',
  'きゅうい',
  'よそゆき',
  'かくいつ',
  'かつぎょ',
  'のりきる',
  'わりふり',
  'ほうけい',
  'ゆさぶり',
  'てっかい',
  'せんぱく',
  'よういく',
  'きずぐち',
  'きりぼし',
  'あっかん',
  'しゅうぎ',
  'ひらまく',
  'ひんめい',
  'こうなん',
  'やくざい',
  'ふきとぶ',
  'かつべん',
  'うりかた',
  'どくはく',
  'だんらく',
  'とうこつ',
  'うつりぎ',
  'かりいれ',
  'つきびと',
  'ほんすう',
  'ゆうげん',
  'ほうまん',
  'ふうさつ',
  'やすらか',
  'ひきつぐ',
  'かたほう',
  'ていしゅ',
  'しっせい',
  'きつもん',
  'だいこう',
  'うらめん',
  'ゆういぎ',
  'ついとつ',
  'おうぼう',
  'ていげん',
  'しゅんじ',
  'いまよう',
  'ばいよう',
  'そうげん',
  'きがまえ',
  'けいがい',
  'やくじょ',
  'えききん',
  'ぞくはつ',
  'でつくす',
  'れんよう',
  'いんねん',
  'くさのね',
  'かつあい',
  'こくない',
  'でいすい',
  'そうしつ',
  'ようせつ',
  'なんこう',
  'かしげる',
  'あやうく',
  'ほくりく',
  'かんすい',
  'ふくいん',
  'たてまえ',
  'がいえん',
  'だんじき',
  'シングル',
  'いひょう',
  'けつまつ',
  'やちょう',
  'ちょうい',
  'にんてい',
  'おうせい',
  'たまねぎ',
  'ふうあつ',
  'びっしり',
  'ちんこう',
  'そういん',
  'けんぴつ',
  'かけあい',
  'ていさい',
  'ひってき',
  'だがっき',
  'ぞうほん',
  'ははのひ',
  'どうしん',
  'おいこむ',
  'きえいる',
  'かたはば',
  'うたひめ',
  'さんにん',
  'そうりふ',
  'しんげき',
  'ぜんがく',
  'せいまい',
  'しゅつど',
  'いえすじ',
  'はがゆい',
  'ふうかく',
  'はたあげ',
  'さきざき',
  'たいかん',
  'ゆうよう',
  'がいまい',
  'ものだね',
  'どうそう',
  'ながあめ',
  'しょかつ',
  'つっぱり',
  'せんてい',
  'のうほう',
  'みうごき',
  'まんめん',
  'とりはだ',
  'わかもの',
  'ながうた',
  'あくだま',
  'ないじつ',
  'きえさる',
  'ほんせん',
  'がくげき',
  'げつがく',
  'ふにあい',
  'みっかい',
  'しゃめん',
  'げんつき',
  'そうしょ',
  'とうしつ',
  'しんかく',
  'かたらう',
  'せいすう',
  'あまみず',
  'わりやす',
  'ぜんもん',
  'まえうり',
  'あやぶむ',
  'じっせい',
  'ぜっさん',
  'うぶごえ',
  'さいあく',
  'ピリオド',
  'にくひつ',
  'こんぱん',
  'かくのう',
  'ちょさく',
  'じんどる',
  'いかがく',
  'ぞうしょ',
  'ていたく',
  'きりこみ',
  'らいうん',
  'のりくむ',
  'すんだん',
  'いっとう',
  'たくほん',
  'えんぐみ',
  'あなどる',
  'てびろく',
  'へいごう',
  'めんしき',
  'てきこく',
  'そくおう',
  'つくだに',
  'たねうま',
  'なつふく',
  'ちゃっか',
  'はくどう',
  'こうおつ',
  'とっぱん',
  'おうとつ',
  'あいよく',
  'へいみん',
  'みすごす',
  'まえむき',
  'はりこむ',
  'のませる',
  'けいそく',
  'しんまい',
  'むぼうび',
  'まいかい',
  'めいうつ',
  'しかばね',
  'いちりつ',
  'ほっかい',
  'さんざん',
  'べいじん',
  'えいやく',
  'のきした',
  'いちがん',
  'どうあげ',
  'かけこむ',
  'めんきょ',
  'くしゅう',
  'うりこみ',
  'りくせん',
  'りんげつ',
  'にじかい',
  'おしまい',
  'あそびば',
  'たくいつ',
  'はやみち',
  'とうかつ',
  'ぼうだん',
  'ちくざい',
  'とりつぐ',
  'かんごふ',
  'きぬいと',
  'くちぶえ',
  'うやむや',
  'りんそん',
  'そうれい',
  'かぶぬし',
  'あいこう',
  'たじゅう',
  'こくがく',
  'しゃこく',
  'ぶつがく',
  'ごうきん',
  'でんたく',
  'ぜんけい',
  'かっとう',
  'どうらん',
  'きわまる',
  'こくはく',
  'こうみん',
  'ぶんこう',
  'なきがお',
  'きょしゅ',
  'しせいじ',
  'きがかり',
  'きりふだ',
  'ぎゅうば',
  'えんねつ',
  'りにょう',
  'しゅえい',
  'つういん',
  'こだかい',
  'もちまえ',
  'めんだん',
  'かいしめ',
  'やまぼこ',
  'いまどき',
  'かさなり',
  'こんしん',
  'かつぼう',
  'けいりん',
  'しつげん',
  'がんじつ',
  'はんてん',
  'こうてき',
  'やまうば',
  'けんじゃ',
  'すいいき',
  'すえひろ',
  'がくわり',
  'へいかい',
  'あさゆう',
  'いっせつ',
  'きんとう',
  'とうじる',
  'のりこし',
  'まんざい',
  'ほうれつ',
  'てんめつ',
  'ぜんせん',
  'くろねこ',
  'ろしゅつ',
  'こつつぼ',
  'しったい',
  'さいせき',
  'ねっぷう',
  'みんぽう',
  'よまわり',
  'ほきょう',
  'くらやみ',
  'さげあし',
  'かきこむ',
  'ひっせき',
  'いわかん',
  'めいかく',
  'おりあい',
  'おおぶね',
  'こうさん',
  'くんこく',
  'ほうろう',
  'よどおし',
  'えんまく',
  'しらぎく',
  'おおなみ',
  'はいざん',
  'ねこじた',
  'ようぎょ',
  'げんえん',
  'けんせい',
  'はいえき',
  'ふほんい',
  'ひゃっか',
  'きりとる',
  'うけざら',
  'なおざり',
  'みくだす',
  'したがき',
  'いたばり',
  'しっする',
  'らんせん',
  'いちおく',
  'そくせき',
  'ゆうすう',
  'たいろん',
  'ほうべん',
  'はなやぐ',
  'せいのう',
  'あかがみ',
  'つじどう',
  'ないこく',
  'とくじゅ',
  'しょだい',
  'じびょう',
  'ラッシュ',
  'こんぺき',
  'やくそう',
  'らんざつ',
  'にげごし',
  'ざつよう',
  'えんもく',
  'へいかん',
  'みずむし',
  'ねぼける',
  'かいはい',
  'ぐんよう',
  'ぜっぴつ',
  'こじんさ',
  'ういまご',
  'かわった',
  'みいだす',
  'ミサイル',
  'しゅうそ',
  'しょじょ',
  'すじがね',
  'しんかん',
  'とっくん',
  'ふうぶつ',
  'いちがつ',
  'わかみや',
  'ろうれん',
  'ほっぺた',
  'てっぺき',
  'えいぞう',
  'とうくつ',
  'ひとなか',
  'いしぶみ',
  'かんさん',
  'かみきれ',
  'せんじん',
  'そくめん',
  'へいせい',
  'ちょうだ',
  'じしょう',
  'ししまい',
  'なつばて',
  'ほんでん',
  'さいこん',
  'せっかん',
  'しんにち',
  'げきてき',
  'しゅもく',
  'かいだし',
  'かなもの',
  'のほうず',
  'でんあつ',
  'ふくへい',
  'みょうが',
  'いすわり',
  'でいたん',
  'こくえき',
  'つみとる',
  'げんとう',
  'ごくぼそ',
  'せいしゅ',
  'とびのる',
  'ねんげん',
  'でんぼう',
  'うすやき',
  'なんぽう',
  'ごりやく',
  'るいぞう',
  'あげさげ',
  'かいだく',
  'きわめる',
  'しずけさ',
  'かくない',
  'ぶんしん',
  'ていぞく',
  'みずさし',
  'いちよく',
  'ゆうれつ',
  'かんごく',
  'うちかけ',
  'ばんづけ',
  'かちこす',
  'ろうさく',
  'べいはん',
  'ちのうみ',
  'にっきん',
  'みずあげ',
  'いざこざ',
  'きょれい',
  'よくげつ',
  'えんとう',
  'うちかつ',
  'きたかぜ',
  'たいしゃ',
  'ぼうれい',
  'じんけん',
  'あやしむ',
  'にほんし',
  'ほくおう',
  'げつめん',
  'もうばく',
  'ほそぼそ',
  'ものいい',
  'つぎはぎ',
  'かきょく',
  'かっくう',
  'ねんこう',
  'こざかな',
  'じんさい',
  'ふんべつ',
  'いえなみ',
  'うずめる',
  'たちのく',
  'でんそろ',
  'おおえだ',
  'けんえい',
  'かちこし',
  'かいめつ',
  'たんらく',
  'はいぞく',
  'ぶつよく',
  'どろみず',
  'くんかい',
  'びゃくや',
  'しきてん',
  'ふくせい',
  'ろうさい',
  'にわかに',
  'さきがけ',
  'はんがん',
  'じかよう',
  'くびすじ',
  'どうたい',
  'りにゅう',
  'ぎょかい',
  'ちゅうき',
  'ウエスト',
  'しかける',
  'ゆういん',
  'ふつぶん',
  'そうじき',
  'なまみず',
  'ぐんかく',
  'そとがわ',
  'くさたけ',
  'あくほう',
  'しょめん',
  'うわぜい',
  'へいめい',
  'こうろん',
  'かんない',
  'せいぎょ',
  'きふじん',
  'ころしや',
  'なげいれ',
  'よびもの',
  'びょうぶ',
  'なげうり',
  'じつだん',
  'ひとくち',
  'ふくだい',
  'そびょう',
  'ぞうがん',
  'ぞうさく',
  'そうばな',
  'ゆるがす',
  'せんえい',
  'きかがく',
  'じんもん',
  'だいざい',
  'そうあん',
  'かいいぬ',
  'ちじょく',
  'ろうじょ',
  'きょどう',
  'かいづか',
  'たいねつ',
  'ひごうり',
  'ひとかわ',
  'こうねつ',
  'ていしん',
  'きんこう',
  'こてさき',
  'じょまく',
  'げんぱい',
  'けんぶん',
  'いっぴつ',
  'はだいろ',
  'しゃいん',
  'ほうがん',
  'やくしん',
  'みどころ',
  'げっぽう',
  'ねころぶ',
  'がいあつ',
  'さっこん',
  'あいづち',
  'ひとなみ',
  'とびちる',
  'かきこみ',
  'ぼうはつ',
  'おみこし',
  'ぬきだす',
  'もうこう',
  'きゅうば',
  'しんざん',
  'つみあげ',
  'えんきり',
  'げんがい',
  'ごはさん',
  'らくごか',
  'じゅぞう',
  'とういん',
  'にいづま',
  'ぜんぷく',
  'けいはつ',
  'はんしゃ',
  'きまりて',
  'しゅじく',
  'うんこう',
  'しつてき',
  'はんそう',
  'わかれめ',
  'せんりつ',
  'はいざい',
  'つくづく',
  'まんだん',
  'ふにんき',
  'はくがく',
  'でんわき',
  'たっかん',
  'きょあく',
  'どんこう',
  'そくとう',
  'とおあさ',
  'どくやく',
  'へだたり',
  'やきそば',
  'かおまけ',
  'こんれい',
  'ひつじゅ',
  'べいしん',
  'ふりょう',
  'いんぜい',
  'けいろう',
  'たいざん',
  'かんぱく',
  'たちがれ',
  'まくぎれ',
  'そうてん',
  'きょうじ',
  'のじゅく',
  'きゅうは',
  'いちまい',
  'びょうご',
  'さんせき',
  'ぞんめい',
  'かいいき',
  'ひっとう',
  'はいいん',
  'かぼちゃ',
  'おおづめ',
  'うわづみ',
  'なかだち',
  'かくねん',
  'こうさつ',
  'ないへき',
  'ほうゆう',
  'ばいしん',
  'かけごえ',
  'くわばら',
  'もんつき',
  'まんるい',
  'どろぬま',
  'なかがき',
  'ちゅうは',
  'うしろで',
  'むじょう',
  'でまわり',
  'はんろん',
  'ふようど',
  'しらうめ',
  'たねつけ',
  'しきべつ',
  'とうひん',
  'がいそう',
  'シューズ',
  'ぶぎょう',
  'どうせい',
  'へいよう',
  'すいがら',
  'はならび',
  'みだしご',
  'れんたつ',
  'さっすう',
  'なつもの',
  'つよがり',
  'まきこむ',
  'ごうはん',
  'ねあがり',
  'せいごう',
  'ほうべい',
  'こおらす',
  'すいおん',
  'くっする',
  'さくづけ',
  'みつもる',
  'ぐたいか',
  'いしかい',
  'ほんるい',
  'よこあな',
  'あきばれ',
  'やりかた',
  'こうふう',
  'ひつだん',
  'ひきさげ',
  'おうけん',
  'ぜんとう',
  'さくがら',
  'どうけい',
  'いきぬき',
  'にくがん',
  'しょだん',
  'ていへん',
  'まぢかい',
  'くうらん',
  'とめおき',
  'あくにん',
  'しおくり',
  'きんぴら',
  'はればれ',
  'ことぶき',
  'こきゃく',
  'しめつけ',
  'たくあん',
  'くちがね',
  'せんこく',
  'ぶんべつ',
  'ざしょう',
  'みらいは',
  'こんわく',
  'さしあみ',
  'ありさま',
  'そうこく',
  'よこしま',
  'むしかく',
  'おおもじ',
  'がいじん',
  'よつぎり',
  'めんぼう',
  'げいごう',
  'みあげる',
  'しらはま',
  'れんばい',
  'そくしつ',
  'かけひき',
  'けっしゃ',
  'しゅのう',
  'しゅざん',
  'ようれい',
  'くろやま',
  'むらびと',
  'さんやく',
  'そうたい',
  'れつでん',
  'あみだす',
  'いなおる',
  'ねんりき',
  'ひきゃく',
  'かいもん',
  'やすうり',
  'ぜんいき',
  'どくとく',
  'おうぶん',
  'ほどなく',
  'ぞうぜい',
  'ゆうたい',
  'うけもち',
  'こまわり',
  'ふかいり',
  'るいしん',
  'もっこう',
  'いっぷく',
  'こんぽん',
  'しゅがん',
  'てつづき',
  'けんちょ',
  'うりぬし',
  'おおさじ',
  'さんいつ',
  'せきはん',
  'ゆうこく',
  'くさわけ',
  'りようし',
  'なきごえ',
  'けんばん',
  'えどまえ',
  'たてがき',
  'よりみち',
  'すきやき',
  'みすてる',
  'ざんせつ',
  'あかいろ',
  'たくはい',
  'そくせい',
  'くちぞえ',
  'ぬきとる',
  'ふれあう',
  'きんしゅ',
  'てさぐり',
  'あいさつ',
  'きわどい',
  'がっさん',
  'ゆうがい',
  'つつぬけ',
  'めんえき',
  'こくふう',
  'トースト',
  'きしどう',
  'しょとう',
  'ないみつ',
  'えんがい',
  'せんばい',
  'げんぺい',
  'まちなみ',
  'ぎんまく',
  'てっせん',
  'みおぼえ',
  'わりきる',
  'みんげい',
  'せいよく',
  'はんけん',
  'みわける',
  'ていさつ',
  'ざんるい',
  'しめりけ',
  'おくりて',
  'どうくつ',
  'じゃけん',
  'しゃどう',
  'むしょう',
  'つったつ',
  'しょうや',
  'こうぶん',
  'ごうまん',
  'ひきこむ',
  'だんどう',
  'さまよう',
  'しきょく',
  'しんあい',
  'かわぞい',
  'にんよう',
  'うたかい',
  'つかいて',
  'よこがき',
  'どうれつ',
  'かしだす',
  'えんどう',
  'ぼくとう',
  'やまがた',
  'ぐんだん',
  'おうへい',
  'みひらき',
  'しんたん',
  'ぶんらく',
  'やきいも',
  'げんそう',
  'きおくれ',
  'ものかげ',
  'かっすい',
  'ちょうし',
  'さきゆき',
  'しんかい',
  'とっけん',
  'とうべん',
  'しかいし',
  'けいもう',
  'つっこみ',
  'ぶんどる',
  'うすれる',
  'だっそう',
  'じょめい',
  'うけいれ',
  'はごいた',
  'たんせん',
  'けんどう',
  'いってつ',
  'たいてん',
  'かいあげ',
  'ひのたま',
  'こういど',
  'ばんたん',
  'えいぞく',
  'けいせき',
  'どきょう',
  'ゆくさき',
  'せいえん',
  'とまどう',
  'つけいる',
  'えりもと',
  'これまで',
  'きょかん',
  'がくれい',
  'だいもん',
  'かちまけ',
  'にょたい',
  'げんゆう',
  'のうこん',
  'つめきり',
  'げんしろ',
  'こくはつ',
  'あきかん',
  'じつがく',
  'かいねこ',
  'びんそく',
  'げきへん',
  'いんせい',
  'ばってい',
  'もじばん',
  'いつわり',
  'ばんがい',
  'そうげい',
  'こくいん',
  'ふじょう',
  'しゃふう',
  'せんのう',
  'ぐんぞく',
  'かくさん',
  'てっこつ',
  'ぼうさい',
  'まんさい',
  'こまかく',
  'ちかしつ',
  'こうない',
  'げんめん',
  'でんてつ',
  'だっする',
  'はいあん',
  'せわやく',
  'はんとし',
  'さんげん',
  'ゆうちょ',
  'きょうと',
  'きりかぶ',
  'どがいし',
  'はじらい',
  'ちゅうさ',
  'さげすむ',
  'はんそで',
  'かたらい',
  'てんやく',
  'くみかえ',
  'しゃそう',
  'ゆめにも',
  'しんそこ',
  'ぶっぴん',
  'まんびき',
  'たいじん',
  'のらねこ',
  'ていせん',
  'むきめい',
  'そうせい',
  'みがわり',
  'ふくやく',
  'かいゆう',
  'かたおや',
  'だんぞく',
  'かけこみ',
  'せいえい',
  'はくさい',
  'れいたん',
  'えいたい',
  'かしつけ',
  'えんやす',
  'いとぐち',
  'のみほす',
  'わじゅつ',
  'るすばん',
  'かつらく',
  'もうとう',
  'じゅえき',
  'さいてき',
  'どうほう',
  'よみきる',
  'きりばな',
  'ばんゆう',
  'けったく',
  'げんろう',
  'でかせぎ',
  'やけいし',
  'たいれつ',
  'さつがい',
  'たくらみ',
  'ひろまり',
  'かたこり',
  'あいぼう',
  'じくうけ',
  'きょこう',
  'やすまる',
  'ほんもと',
  'おんそく',
  'だいひつ',
  'つうぞく',
  'おいこみ',
  'まけんき',
  'きょてん',
  'ていれい',
  'おくまる',
  'せんぬき',
  'びょうり',
  'はえぬき',
  'いいあう',
  'おうかん',
  'ちょくし',
  'こうそつ',
  'めいせい',
  'らんそう',
  'ももいろ',
  'かしわぎ',
  'らんおう',
  'まめるい',
  'ぞくへん',
  'つりばり',
  'でんじゅ',
  'かたうで',
  'かちとる',
  'しはんき',
  'ふれあい',
  'ながいす',
  'ひくめる',
  'ねぶくろ',
  'くちどめ',
  'なんみん',
  'やわらか',
  'きょとう',
  'そうれつ',
  'たいやく',
  'ようしつ',
  'さんめん',
  'まどごし',
  'でんじき',
  'うちあい',
  'ねづよい',
  'じつどう',
  'れきぜん',
  'じょうじ',
  'とっさに',
  'ぞっこう',
  'いのこる',
  'すいもん',
  'にるいだ',
  'ふういん',
  'しちゅう',
  'じんえん',
  'じしゅく',
  'かざりけ',
  'べんりし',
  'とうない',
  'れつあく',
  'じょうと',
  'ひんのう',
  'とりまく',
  'いちもん',
  'あいのり',
  'かえだま',
  'しょくん',
  'ばんめん',
  'であるく',
  'しなじな',
  'じんけい',
  'はごろも',
  'りょうひ',
  'やっかん',
  'さしこみ',
  'ゆだねる',
  'じゃくし',
  'しょくご',
  'そんかい',
  'くまなく',
  'まきもの',
  'ふっかん',
  'ましかく',
  'あしくび',
  'どよめく',
  'もちこむ',
  'じつめい',
  'けんしき',
  'しょろん',
  'ながらく',
  'どうじん',
  'さくぶん',
  'たくらむ',
  'なんせい',
  'ほんすじ',
  'じょしゅ',
  'たんでん',
  'くりいれ',
  'こっけん',
  'どうぶん',
  'かちぼし',
  'ついおく',
  'ちかどう',
  'がいきん',
  'しゅせい',
  'がくどう',
  'としうえ',
  'たんねん',
  'とらわれ',
  'なかつぎ',
  'まいふん',
  'せめこむ',
  'そうろん',
  'りっけん',
  'きょじつ',
  'たくぼく',
  'すうしき',
  'なだかい',
  'そくだん',
  'はっかん',
  'てんきず',
  'さいして',
  'みせしめ',
  'かたわく',
  'かんけん',
  'そうぜん',
  'あしなみ',
  'べっこう',
  'せいじゃ',
  'みんしん',
  'ほしゅう',
  'めいてん',
  'みつおり',
  'たんぷく',
  'なげこむ',
  'つきそい',
  'きょうぶ',
  'すのもの',
  'まえがみ',
  'どたんば',
  'せいへん',
  'さいかく',
  'もくはん',
  'のうさん',
  'けいふく',
  'けんしん',
  'せっぽう',
  'あんらく',
  'どうきょ',
  'こつばん',
  'やくがい',
  'ほらあな',
  'とうほく',
  'こうはく',
  'もくさん',
  'ききやく',
  'ゆうあい',
  'みんけん',
  'いちじゅ',
  'うらやま',
  'やくわり',
  'こんぜつ',
  'さんろく',
  'ぎょるい',
  'みせばん',
  'がっかい',
  'ちんぴん',
  'ぜかひか',
  'ひとがき',
  'りっぷく',
  'ぞうてい',
  'さきだか',
  'ないはつ',
  'こうてん',
  'じゅこう',
  'りょうぼ',
  'けいらん',
  'だんざい',
  'べにいろ',
  'そうだち',
  'どうもん',
  'ぎゃくて',
  'さくどう',
  'どうかつ',
  'じちたい',
  'しょりん',
  'ごくひん',
  'しぎかい',
  'ちんあげ',
  'ざいにち',
  'げいぶん',
  'あおいろ',
  'はんどう',
  'よこはば',
  'ねぶかい',
  'りんこう',
  'うんかい',
  'とくひつ',
  'ひとびと',
  'さんなん',
  'ぞうびん',
  'ですぎる',
  'とつげき',
  'きょうく',
  'げんぜい',
  'すいてい',
  'ばいがく',
  'ぐんそう',
  'きんしん',
  'とじょう',
  'ぜんぺん',
  'たいあん',
  'まくうち',
  'くちぐせ',
  'がくたい',
  'らんぽう',
  'さいねん',
  'ばんそう',
  'ぼくそう',
  'こうかく',
  'かおやく',
  'ふみきる',
  'なんぜん',
  'ぶきよう',
  'もくたん',
  'はぐくむ',
  'もしょう',
  'えんせき',
  'たまつき',
  'ものほし',
  'こういき',
  'きゅうと',
  'かざむき',
  'せいふう',
  'しゅくば',
  'よなおし',
  'ふみだす',
  'とちょう',
  'ざんぞう',
  'てんまど',
  'しなうす',
  'てきじん',
  'しれいぶ',
  'またせる',
  'こしなわ',
  'すじみち',
  'かくへき',
  'いしゅう',
  'ようすい',
  'きんざん',
  'おりあう',
  'さしこむ',
  'ぶっかく',
  'しんぺん',
  'すいあつ',
  'すみやか',
  'せんちゃ',
  'やまはだ',
  'はんいん',
  'せんらん',
  'ここのえ',
  'あくとく',
  'つけこむ',
  'こんせつ',
  'れんこう',
  'はくあき',
  'げいめい',
  'がんめん',
  'へんしょ',
  'こんがん',
  'ひるすぎ',
  'とくしか',
  'ぎりょう',
  'もうはつ',
  'みりょう',
  'ばいたい',
  'めいしゅ',
  'うちこみ',
  'てんくう',
  'かきぞめ',
  'ばけもの',
  'ひつどく',
  'りんがく',
  'いのこり',
  'みっこく',
  'おんけん',
  'ぜんだい',
  'じょさん',
  'さんぴん',
  'きみつひ',
  'はつゆき',
  'あかしお',
  'はんもと',
  'いとしい',
  'みつやく',
  'もくへん',
  'かりょく',
  'まっこう',
  'ひらける',
  'じふぶき',
  'しおみず',
  'ていはく',
  'べつずり',
  'へいぜい',
  'てきやく',
  'ばちがい',
  'あっせん',
  'あくとう',
  'おうらい',
  'たいない',
  'うけおい',
  'ひじょう',
  'しゃじつ',
  'せいはん',
  'しゅんう',
  'うまぬし',
  'まよわす',
  'せんてつ',
  'よぎなく',
  'こんだん',
  'いんずう',
  'ねっけつ',
  'さいもく',
  'めつぼう',
  'ふかかい',
  'おくない',
  'どうしつ',
  'さいしゅ',
  'はいらん',
  'しおから',
  'きびしさ',
  'たからか',
  'じょそう',
  'けっとう',
  'いりゅう',
  'むしくい',
  'ふんせん',
  'のうえん',
  'ひきあい',
  'はげまし',
  'きょせい',
  'あおうめ',
  'きやすい',
  'すえつけ',
  'ほんまる',
  'よぎない',
  'ようさん',
  'みあたる',
  'こくえい',
  'ひらたい',
  'ふんげき',
  'おやだま',
  'おいぬく',
  'はつれい',
  'いっそく',
  'ふかぶん',
  'しゅこう',
  'さんそん',
  'くちぶり',
  'とびこす',
  'ゆうほう',
  'みすえる',
  'おうどう',
  'ねんきん',
  'ざいがい',
  'ぜいもく',
  'えんぐん',
  'はつどう',
  'ざんぱい',
  'じゅんに',
  'あんぎゃ',
  'ぞうかん',
  'いっぴん',
  'さんだん',
  'がくさい',
  'にんかん',
  'ぞくしん',
  'めいがら',
  'くぎょう',
  'どうげつ',
  'こげつき',
  'つれそう',
  'やおもて',
  'くもゆき',
  'てんどう',
  'むしけん',
  'えきしゃ',
  'がくそく',
  'てきぜん',
  'ようしき',
  'おしえご',
  'ほくよう',
  'ふしゅう',
  'てごわい',
  'そなわる',
  'かしきり',
  'ぜんぶん',
  'ふりむく',
  'ささはら',
  'わくない',
  'しおれる',
  'ぜっぺき',
  'ちょうば',
  'かんぱん',
  'だんねん',
  'はくしゃ',
  'なわとび',
  'ディスコ',
  'とおまき',
  'ごうしゃ',
  'とぼける',
  'せいすい',
  'がいでん',
  'くわだて',
  'かんじん',
  'おてもり',
  'てっきょ',
  'やしょく',
  'うらがわ',
  'ふじさん',
  'えきでん',
  'れいてつ',
  'ぶんべん',
  'なかせる',
  'そっこう',
  'すみきる',
  'おうさつ',
  'ないせい',
  'らんぐん',
  'くりのべ',
  'しっかん',
  'むぎちゃ',
  'てにもつ',
  'てりやき',
  'まんえん',
  'ふしょく',
  'てきにん',
  'ちゅうび',
  'ようじょ',
  'てづくり',
  'くろしろ',
  'ろんこく',
  'げつれい',
  'まえがり',
  'あなうめ',
  'しほんか',
  'ぎんがみ',
  'ふかのう',
  'ぜんじつ',
  'みひらく',
  'かきゅう',
  'ていおう',
  'なつやま',
  'ろんしゃ',
  'ひぎしゃ',
  'かいへん',
  'ゆうざい',
  'せいさい',
  'ぜんえい',
  'てんしゃ',
  'じっけい',
  'たいほう',
  'とうおう',
  'えきべん',
  'しごとし',
  'かたとき',
  'かけいぼ',
  'げんかく',
  'へんてつ',
  'ぜいせい',
  'びじゃく',
  'ままはは',
  'しょくふ',
  'ういじん',
  'うすまく',
  'いろどる',
  'しんげつ',
  'ぐんじゅ',
  'うずまく',
  'ふくとく',
  'かいざい',
  'たかなみ',
  'みごろし',
  'チャック',
  'ぐちょく',
  'しろうと',
  'じんいん',
  'わがくに',
  'あくたい',
  'さいたん',
  'しゅぜい',
  'せいはつ',
  'たちきる',
  'ほそうで',
  'むりやり',
  'しつない',
  'じんとり',
  'しゃれい',
  'いっきょ',
  'じむいん',
  'ひとあし',
  'こみあう',
  'さいれい',
  'くるわす',
  'ふくがん',
  'ばんけん',
  'あついた',
  'にっけい',
  'ぜんげん',
  'そうてい',
  'いんどう',
  'つりぶね',
  'じつざい',
  'はんげつ',
  'かわりみ',
  'なんより',
  'きくばり',
  'かたあし',
  'けんしゅ',
  'むしゅう',
  'つみこむ',
  'ろんきょ',
  'こくさく',
  'ふりこう',
  'ぞくせつ',
  'かんきん',
  'きづかう',
  'あんこく',
  'ざいらい',
  'にぎらす',
  'きしゅう',
  'こうちん',
  'どうがん',
  'せんゆう',
  'かんいん',
  'たがいに',
  'ごうかい',
  'ぶんてん',
  'もちだし',
  'ひんみん',
  'そんきん',
  'こうひつ',
  'ずいはん',
  'おどりこ',
  'ていそく',
  'まいった',
  'むりじい',
  'いっしき',
  'かんだん',
  'あまりに',
  'ぜんだん',
  'あかはた',
  'りしょく',
  'もうせい',
  'こひつじ',
  'いっぱく',
  'のきさき',
  'あいこく',
  'じすべり',
  'せきしつ',
  'るいしょ',
  'つうかい',
  'しゅせき',
  'そじょう',
  'ざっそく',
  'いつざい',
  'しょぞう',
  'みずくさ',
  'まんぱい',
  'しゅかく',
  'さんぐう',
  'がっさく',
  'みならい',
  'りょだん',
  'しんえん',
  'しゅけい',
  'げきとう',
  'ぞっかん',
  'こうのう',
  'ほうよう',
  'しゅうち',
  'なんかい',
  'りきさく',
  'とうだん',
  'えっけん',
  'とうじつ',
  'おおもり',
  'しゅとう',
  'ぶしょう',
  'じょてい',
  'ふうせつ',
  'てきおん',
  'こうゆう',
  'てごたえ',
  'とおりま',
  'くれない',
  'ねんいり',
  'ふちゃく',
  'ようりつ',
  'ゆうせつ',
  'バーゲン',
  'ひんそう',
  'とうぐう',
  'くうかん',
  'だいぎし',
  'やまねこ',
  'ほうへい',
  'おおぐち',
  'けんすう',
  'てきれい',
  'なりわい',
  'すじあい',
  'うじがみ',
  'ごうせん',
  'ていれん',
  'おかざり',
  'うりきる',
  'こうじる',
  'おんみつ',
  'くさぶえ',
  'あいのて',
  'かいもく',
  'かんぽう',
  'やまなみ',
  'ひつめい',
  'すいなん',
  'さきどり',
  'じゅしん',
  'じっすう',
  'しんえい',
  'みずわり',
  'えいかん',
  'つれだつ',
  'じゅさん',
  'うながす',
  'まちなか',
  'めいうん',
  'とうすい',
  'ちちゅう',
  'ばじょう',
  'げきしん',
  'そうぜい',
  'じきひつ',
  'きゅうり',
  'たんぶん',
  'かいぞく',
  'しろあと',
  'かくげん',
  'いねかり',
  'ぞうせん',
  'ついでに',
  'しょろう',
  'りょうて',
  'おおあめ',
  'てんぷく',
  'けんもん',
  'こくせい',
  'ほうねん',
  'かいにん',
  'ぼっぱつ',
  'だいどう',
  'たいすい',
  'たびだつ',
  'かいめん',
  'とこなつ',
  'えいへい',
  'さきゅう',
  'いままで',
  'だつぼう',
  'ながもち',
  'りんさん',
  'こめつぶ',
  'めいちょ',
  'えはがき',
  'こうらく',
  'ついにん',
  'しょこく',
  'さまたげ',
  'おおくら',
  'くりこし',
  'こうとく',
  'かげろう',
  'てきごう',
  'のうひん',
  'まくあけ',
  'かいぐん',
  'おしだし',
  'ぞうちく',
  'ふたしか',
  'ざっとう',
  'はなたば',
  'しょこん',
  'しにたい',
  'きっこう',
  'ぜんけん',
  'かわきり',
  'しんばし',
  'れいふく',
  'がいめん',
  'ぜんれつ',
  'しろぼし',
  'かためん',
  'けいほう',
  'ようかい',
  'おおもと',
  'さいげつ',
  'けつれつ',
  'だんそう',
  'かんまん',
  'くみとる',
  'こうぐん',
  'らんかく',
  'よりそう',
  'じんぶん',
  'げんあん',
  'いれずみ',
  'こうりん',
  'とくほん',
  'へんさい',
  'かんぼつ',
  'さんたい',
  'やまぎわ',
  'そうざん',
  'みおとり',
  'じゅうど',
  'かっせい',
  'かおぶれ',
  'かりもの',
  'こなゆき',
  'くじゃく',
  'はいにち',
  'がんちく',
  'みずぐち',
  'かくとう',
  'えいれい',
  'なんしょ',
  'かんだい',
  'きごこち',
  'せんれつ',
  'ひらめく',
  'ぞうへい',
  'にんじゃ',
  'いきかた',
  'ひょうり',
  'どうけん',
  'おみくじ',
  'かれくさ',
  'かいまく',
  'いちじき',
  'まるがお',
  'せいれん',
  'きつえん',
  'めんざい',
  'あととり',
  'ぎょうこ',
  'あいけん',
  'とびきり',
  'いっけん',
  'ばくおん',
  'きゃくま',
  'こうえつ',
  'ざっこく',
  'きりかえ',
  'りゅうい',
  'すいれい',
  'こうやく',
  'いんぼう',
  'もちあい',
  'ざいべい',
  'たいちょ',
  'ぜんだま',
  'もくさつ',
  'きりょう',
  'にげみち',
  'ないかい',
  'せんばつ',
  'たいげん',
  'ごちょう',
  'だいする',
  'じむしつ',
  'おいうち',
  'たくばつ',
  'ふりえき',
  'ごうべん',
  'まよなか',
  'きんいつ',
  'ひややか',
  'じんえい',
  'そうむぶ',
  'どじょう',
  'いんりつ',
  'ききゅう',
  'もくげき',
  'えいのう',
  'ぜっせん',
  'いっかい',
  'かいりつ',
  'ほしがる',
  'あざける',
  'かりきる',
  'あしもと',
  'しゅらば',
  'てきほう',
  'ろんせつ',
  'べつだん',
  'やりくり',
  'しんれい',
  'ながいき',
  'かいおん',
  'ひきとり',
  'さいへん',
  'ほけんふ',
  'けんさつ',
  'しゃげき',
  'れんさい',
  'らくがき',
  'じゃあく',
  'おもしろ',
  'あおぞら',
  'かんぬし',
  'たいにち',
  'つぐない',
  'ぶっさん',
  'いちじょ',
  'はたいろ',
  'せきめん',
  'しんぞく',
  'かくあげ',
  'でんげき',
  'ぶっせい',
  'いちぼう',
  'よこじく',
  'とっこう',
  'ぼうくん',
  'ばくろう',
  'うけあう',
  'ひきうけ',
  'ふれこみ',
  'おもわく',
  'はこづめ',
  'たいさい',
  'へいあん',
  'かいらく',
  'あまぐも',
  'くりあげ',
  'げんすん',
  'しっぺい',
  'めくじら',
  'まどわす',
  'こいぶみ',
  'りがくぶ',
  'てつわん',
  'みずまし',
  'ばっさい',
  'だいしゃ',
  'うちきり',
  'じつえん',
  'きじゅう',
  'かれえだ',
  'なんもん',
  'こくえん',
  'あさやけ',
  'のりあい',
  'てまどる',
  'くうほう',
  'せきつい',
  'せんたん',
  'はいれい',
  'ドクター',
  'やくぶん',
  'かくしき',
  'さんだい',
  'ひじゅん',
  'ならわし',
  'ちゅうざ',
  'まいひめ',
  'かっぱん',
  'せつげん',
  'じっしゃ',
  'しらゆり',
  'どっかい',
  'ばんとう',
  'つゆあけ',
  'ぼうすい',
  'こだから',
  'かたがみ',
  'あとがき',
  'さしいれ',
  'ろうがん',
  'しんきん',
  'ながぐつ',
  'いんしゅ',
  'ぜんりん',
  'しかえし',
  'しんずい',
  'おんせい',
  'ばくしん',
  'ていとう',
  'しょせい',
  'どうしゅ',
  'きょくぶ',
  'けんかく',
  'むきげん',
  'ともづり',
  'かいどく',
  'ひっつく',
  'こつずい',
  'もちだす',
  'つぎこむ',
  'がいけん',
  'こくめい',
  'ばあさん',
  'あけぼの',
  'かいせん',
  'くちかず',
  'だんやく',
  'やきにく',
  'いちらん',
  'たちさる',
  'あしかけ',
  'ちんせい',
  'そこびえ',
  'ふううん',
  'べつめい',
  'つみたて',
  'あわもり',
  'とちがら',
  'よびかけ',
  'かいしん',
  'へいふく',
  'かなあみ',
  'いしぐみ',
  'おこたり',
  'おしばな',
  'のぞいて',
  'はいがい',
  'ぐんとう',
  'えがたい',
  'ほごしゃ',
  'へんせつ',
  'まんがか',
  'ぎんいろ',
  'ないてき',
  'じひょう',
  'けいしつ',
  'びようし',
  'えんしょ',
  'にくせい',
  'きわだつ',
  'はわたり',
  'だんぜつ',
  'さしとめ',
  'ななくさ',
  'しょうわ',
  'あいかん',
  'かみつく',
  'はんかん',
  'なまごみ',
  'もんぜん',
  'せいどう',
  'たんめい',
  'たいばん',
  'うきぼり',
  'げきつい',
  'しきけん',
  'きんけん',
  'よりあい',
  'へいまく',
  'わりこみ',
  'かたがわ',
  'せっぷく',
  'そうせつ',
  'ぞうけい',
  'たいはく',
  'がんさく',
  'おやかた',
  'とりぶん',
  'みちくさ',
  'おとこで',
  'めんみつ',
  'うらきど',
  'おおごえ',
  'かいきょ',
  'れいせん',
  'のりつぐ',
  'すえおき',
  'けんごう',
  'だんねつ',
  'ぎむてき',
  'りきせつ',
  'にっかん',
  'ようしょ',
  'がいへき',
  'ていたい',
  'できあい',
  'たいべつ',
  'ひんかく',
  'しぶがき',
  'かんぞう',
  'そうめい',
  'しんうち',
  'せんけん',
  'あくるひ',
  'としあけ',
  'さくげき',
  'さくそう',
  'らくえん',
  'たいあつ',
  'ちょっか',
  'せっぱく',
  'だんがい',
  'れいこく',
  'ひきあて',
  'へいぼん',
  'そくしん',
  'ぜいりし',
  'よくじつ',
  'たいせき',
  'らんぱつ',
  'ゆきどけ',
  'ねがえる',
  'ふっけん',
  'よこづけ',
  'どうぼう',
  'ぎもんふ',
  'あしばや',
  'せんぷく',
  'はじょう',
  'サッカー',
  'なにゆえ',
  'ぜいびき',
  'あげもの',
  'そうふう',
  'めんぼく',
  'せいふん',
  'ちゃばん',
  'はんべつ',
  'じっそく',
  'せきさん',
  'かきだし',
  'こくじん',
  'かわぞこ',
  'けいれつ',
  'くりだす',
  'できだか',
  'ひえこむ',
  'れんりつ',
  'ともども',
  'げっさん',
  'とびこみ',
  'さかぐら',
  'さんぜん',
  'しゅたる',
  'けいえん',
  'ぜんじん',
  'だしもの',
  'にゅうか',
  'どうてい',
  'ひっしゃ',
  'ゆうぐう',
  'ていけつ',
  'ちゅうぶ',
  'じゅどう',
  'せいへき',
  'みんだん',
  'とうほん',
  'だんろん',
  'さよなら',
  'とうらく',
  'かんごう',
  'しりゅう',
  'ふどうい',
  'たんぱく',
  'かいすい',
  'ぜっぴん',
  'しじょう',
  'かくする',
  'だいかん',
  'しばいぬ',
  'ぜいこみ',
  'せいたく',
  'さいじん',
  'かなしみ',
  'ほんばこ',
  'てならい',
  'てんない',
  'がんぽん',
  'ぶっぽう',
  'いましめ',
  'いしゅく',
  'まるぼん',
  'はつあん',
  'よびこう',
  'かけもち',
  'まいそう',
  'にまいめ',
  'ははかた',
  'ひいでる',
  'せんかい',
  'たきがわ',
  'みっしつ',
  'けいよう',
  'みちすじ',
  'うれえる',
  'ほんいん',
  'えんない',
  'かふそく',
  'かぎゃく',
  'せつじょ',
  'もちこみ',
  'すいこう',
  'ぶどまり',
  'せいえき',
  'こうべん',
  'ぬきさる',
  'たんせい',
  'わずらう',
  'きょくさ',
  'ろんこう',
  'べってい',
  'ぼうよみ',
  'いっこく',
  'ふいうち',
  'はいえん',
  'げいにく',
  'いろあい',
  'にっさん',
  'ひっそり',
  'せいれい',
  'げんぞん',
  'りきてん',
  'はいかん',
  'ごうぞく',
  'かくがい',
  'ものうり',
  'きっする',
  'のうさい',
  'げんこつ',
  'かいろう',
  'あさぎり',
  'はちがつ',
  'みまわり',
  'のりだす',
  'まけいぬ',
  'うらにわ',
  'もちぶん',
  'おくやま',
  'かんたく',
  'ぜつめつ',
  'やちぐさ',
  'おおあじ',
  'ひろがり',
  'ふなよい',
  'ただいま',
  'つきやま',
  'きたぐに',
  'ていくう',
  'ちんあつ',
  'りゅうき',
  'じんだい',
  'さくぼう',
  'おしぼり',
  'いとめる',
  'しょうむ',
  'せいろん',
  'じゅふん',
  'かよわい',
  'らいれき',
  'まかなう',
  'けっそん',
  'らくせい',
  'そうけい',
  'ひとさま',
  'かろやか',
  'ぜんあく',
  'かくほう',
  'てわたす',
  'けつじょ',
  'こひょう',
  'さっきん',
  'りしゅう',
  'にんめん',
  'あさめし',
  'たいらん',
  'にりゅう',
  'ちょすい',
  'したがわ',
  'みちすう',
  'あかつち',
  'ゆうじょ',
  'とくしゃ',
  'ししょく',
  'スリップ',
  'ねんがん',
  'せつがん',
  'だいきぼ',
  'かんもん',
  'じゅがく',
  'くうはく',
  'よざくら',
  'てんばい',
  'げんせき',
  'かしきん',
  'ねっせん',
  'じゅだく',
  'そんぱい',
  'だんごう',
  'ほしゃく',
  'じんつう',
  'もうどく',
  'かたくな',
  'りつあん',
  'めがしら',
  'ばっきん',
  'ひとまく',
  'じょかん',
  'にのあし',
  'レンタル',
  'にほんが',
  'しらたま',
  'こうらい',
  'えいこう',
  'むじるし',
  'はいほん',
  'おおびけ',
  'ようにん',
  'れいだい',
  'かわはば',
  'けいそう',
  'さんげき',
  'のみすぎ',
  'くるまざ',
  'はんぜん',
  'しょぼう',
  'てづまり',
  'べんてん',
  'はいやく',
  'ぐんがく',
  'ふたつめ',
  'しおかぜ',
  'じしょく',
  'でそろう',
  'おしらせ',
  'わりびく',
  'おかえし',
  'ゆいしょ',
  'さんぶん',
  'がんえん',
  'にわとり',
  'がくそつ',
  'フルーツ',
  'ぼうかん',
  'ないしょ',
  'ちくりん',
  'はくげき',
  'のうどう',
  'がったい',
  'えつねん',
  'たんがん',
  'ざいめい',
  'けんじん',
  'ぜいがく',
  'ぼうくう',
  'ちかづき',
  'かりとり',
  'はたさく',
  'とうけん',
  'きょうほ',
  'ありゅう',
  'うめしゅ',
  'きょだつ',
  'こうおん',
  'すいさつ',
  'みせさき',
  'じょくん',
  'はんぽん',
  'ぶんばい',
  'ざっそう',
  'ひきにく',
  'がいはく',
  'いちばい',
  'せばまる',
  'にゅうじ',
  'だんじて',
  'ひきげき',
  'たびさき',
  'キッチン',
  'てばやい',
  'ざんがく',
  'べっとう',
  'おりこみ',
  'おおまか',
  'めばえる',
  'いやおう',
  'きゅうし',
  'だいこん',
  'じょうり',
  'じんりき',
  'ひがえり',
  'いきょう',
  'じかたび',
  'まくらえ',
  'ぎだゆう',
  'にいさん',
  'おやぶん',
  'まんせき',
  'そんらく',
  'あさがけ',
  'まぜもの',
  'さんがつ',
  'はんざつ',
  'かいめい',
  'しゃよう',
  'けんべん',
  'おうしつ',
  'まかない',
  'かちえる',
  'こんたん',
  'へいめん',
  'いとなみ',
  'がいしん',
  'こがたな',
  'どうらく',
  'ふんしゃ',
  'いとてき',
  'かくづけ',
  'ころびね',
  'すうまん',
  'ないてい',
  'しょぐう',
  'かるくち',
  'こうくん',
  'ゆうかい',
  'さんどう',
  'えんけい',
  'こうぼく',
  'いちぐん',
  'ばいかい',
  'すじょう',
  'せんめん',
  'とうがい',
  'たんのう',
  'しらぬい',
  'せいざい',
  'よびみず',
  'きかせる',
  'がいこつ',
  'したむき',
  'はくじつ',
  'ぶんせき',
  'せんてん',
  'うらがき',
  'てんざい',
  'じくあし',
  'おさまり',
  'べっさつ',
  'しゅたい',
  'ついとう',
  'あえもの',
  'やくがら',
  'いいかえ',
  'こじょう',
  'ぶってん',
  'ちちかた',
  'せりあう',
  'じゅけい',
  'じつろく',
  'きんいろ',
  'たいどう',
  'にゅうわ',
  'いすわる',
  'いっさく',
  'せったい',
  'げっけい',
  'ふくつう',
  'ふりつけ',
  'かいつう',
  'ひょうじ',
  'きれはし',
  'ふくえき',
  'なんぶつ',
  'スタッフ',
  'ともぐい',
  'しゅぼう',
  'いっぱつ',
  'いんせき',
  'ぎょくろ',
  'こざいく',
  'やわらぐ',
  'うなずく',
  'ゆびさき',
  'ながそで',
  'だいおう',
  'もくせい',
  'そくじつ',
  'ようとん',
  'べいじゅ',
  'てびろい',
  'ひとづま',
  'かつげき',
  'かくめん',
  'ひやとい',
  'いちぐう',
  'かるがる',
  'むきしつ',
  'いれかえ',
  'ふうあい',
  'ろんだん',
  'あずかり',
  'ばいめい',
  'よくねん',
  'なりきん',
  'よびごえ',
  'しゃだい',
  'ぎょかく',
  'がいてき',
  'とうしん',
  'てがかり',
  'ふくする',
  'じゅうゆ',
  'はくまい',
  'ぞういん',
  'はむかう',
  'いごこち',
  'とうらい',
  'ゆうだい',
  'ないざい',
  'まくした',
  'さんまい',
  'けつにく',
  'しゅちょ',
  'みずきり',
  'りくそう',
  'たいめい',
  'りゅうぎ',
  'かなしげ',
  'みんえい',
  'あつえん',
  'ろうはい',
  'じゅんど',
  'しっこく',
  'のうりん',
  'せんべん',
  'ぐうぞう',
  'ひんじゃ',
  'ざちょう',
  'ふきつけ',
  'ばくふう',
  'しんねん',
  'がんこう',
  'ふうきり',
  'ばくやく',
  'なんおう',
  'あらなみ',
  'ゆきやま',
  'こばなし',
  'しおじり',
  'くろかみ',
  'えきとう',
  'にがむし',
  'からくち',
  'せんしょ',
  'えんいん',
  'はばたく',
  'ききこみ',
  'にちべい',
  'けんきん',
  'たちよみ',
  'ほねぬき',
  'りんせい',
  'たいしん',
  'じゅうご',
  'てんずる',
  'だいそう',
  'びしょく',
  'れいめい',
  'いっきに',
  'あきぐち',
  'いたまえ',
  'いっつい',
  'はいぐう',
  'みょうり',
  'やまかげ',
  'りくあげ',
  'げんどう',
  'たにがわ',
  'ほうがい',
  'ないあつ',
  'しんやく',
  'せきはい',
  'へんたい',
  'しゅうや',
  'べっかく',
  'おうじゃ',
  'せんだん',
  'かけよる',
  'ぼうだい',
  'はいだん',
  'すいきょ',
  'はいぼく',
  'きょうゆ',
  'まけこし',
  'のうたん',
  'ほんそく',
  'おんてい',
  'ぬすびと',
  'そんぞく',
  'むりかい',
  'はちまき',
  'スモッグ',
  'わくぐみ',
  'すりこむ',
  'とくれい',
  'じりょく',
  'カップル',
  'ようこそ',
  'なにかと',
  'つうこん',
  'ほうじん',
  'しょほう',
  'みつりん',
  'みずかさ',
  'さんれつ',
  'わがはい',
  'あくよう',
  'がいせん',
  'もんげん',
  'はんこつ',
  'きょうむ',
  'ひやめし',
  'まきがみ',
  'なないろ',
  'だんとう',
  'がいしゃ',
  'だじゅん',
  'かいみん',
  'ゆうらん',
  'げんめつ',
  'つうせき',
  'ろうぼく',
  'あんもく',
  'てのこう',
  'わりだか',
  'かりだす',
  'らいほう',
  'ひょうが',
  'いきまく',
  'かくさげ',
  'ひとりで',
  'ごうけつ',
  'こうめい',
  'しゅすい',
  'やまごや',
  'そうねん',
  'かんざい',
  'ぶんごう',
  'おおぶり',
  'けついん',
  'ついずい',
  'らんばい',
  'うえじに',
  'おももち',
  'いしずえ',
  'ふうそく',
  'おいかぜ',
  'かたづけ',
  'もちづき',
  'かまもと',
  'ていえん',
  'ほうえい',
  'なんだい',
  'かべがみ',
  'さとおや',
  'はやばや',
  'れんざん',
  'たけのこ',
  'よみとる',
  'ひとばん',
  'うずまき',
  'ようにく',
  'ぞうはつ',
  'すいあげ',
  'しゃめい',
  'かけあう',
  'さいしん',
  'ふじゅん',
  'ねえさん',
  'あつがみ',
  'ていぼく',
  'いいなり',
  'へきめん',
  'れいはい',
  'さかりば',
  'たいさん',
  'みかえし',
  'ぶんはく',
  'くちぐち',
  'びょうま',
  'もんばん',
  'あせばむ',
  'いきすぎ',
  'いしやま',
  'あくしつ',
  'しんすい',
  'あんけん',
  'せいあん',
  'りょてい',
  'どくがく',
  'しっこう',
  'スプレー',
  'やまのて',
  'まっちゃ',
  'へいだん',
  'まなざし',
  'さつたば',
  'ねつぼう',
  'ふくじゅ',
  'おうてん',
  'ざっきん',
  'ふじょし',
  'きれこみ',
  'わきやく',
  'とっぱつ',
  'けんぺい',
  'てんこく',
  'ろうかく',
  'めいばん',
  'はっかく',
  'みつだん',
  'しょくば',
  'しらゆき',
  'かていか',
  'しっつい',
  'こわがる',
  'ふなづみ',
  'ぼうらく',
  'さかだな',
  'せつだん',
  'ばんかん',
  'よせがき',
  'へいはつ',
  'かんえん',
  'くろふね',
  'がんぼう',
  'ようきん',
  'みまもる',
  'ざっしゅ',
  'せいあい',
  'あわさる',
  'えんのう',
  'ゆきぐに',
  'ふゆかい',
  'なにやら',
  'どうねん',
  'はたおり',
  'めいあん',
  'おわりね',
  'しょかん',
  'てがたい',
  'べんりさ',
  'いにゅう',
  'みたてる',
  'わしょく',
  'ぐんぜい',
  'くにがら',
  'ぞうさつ',
  'うすくち',
  'せりあい',
  'プライド',
  'もうじゃ',
  'こうぼう',
  'がんもく',
  'えんだて',
  'あっさつ',
  'ゆうけい',
  'いちげき',
  'わたくし',
  'のうこつ',
  'ふけやく',
  'はいめん',
  'しょする',
  'ひめぎみ',
  'へんせい',
  'しんもん',
  'れいぐう',
  'がいして',
  'ざんしょ',
  'ぶじゅつ',
  'げんこく',
  'はみでる',
  'ごしょく',
  'あにでし',
  'いきない',
  'ふんえん',
  'じきょう',
  'じゅんじ',
  'れっきょ',
  'たてじく',
  'とりこむ',
  'ほうぼく',
  'たびびと',
  'ろうえい',
  'しゅうは',
  'はんてい',
  'めいさい',
  'はちうえ',
  'せんじゃ',
  'わりあて',
  'としこし',
  'ふだんぎ',
  'せいそく',
  'うなばら',
  'ふみこみ',
  'こんぜん',
  'いきぎれ',
  'すいこむ',
]
